// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Core Color Palette - Premium Qintra Fiery Orange Theme */
  --bg-page: #f8fafc;
  --bg-card: #ffffff;
  --bg-sidebar: #ffffff;
  /* Pure white sidebar background */
  --sidebar-text: #64748b;
  /* Slate/dark text */
  --sidebar-hover: #f8fafc;
  /* Light hover */
  --sidebar-active-bg: #fff7ed;
  /* Very light orange pill background */
  --sidebar-active-text: #FD6101;
  /* Vibrant fiery orange text */

  --primary: #FD6101;
  /* Qintra mid-body fiery orange primary */
  --primary-hover: #e05300;
  --primary-light: #fff7ed;

  --success: #10b981;
  --success-light: #ecfdf5;
  --success-border: #a7f3d0;

  --error: #ef4444;
  --error-light: #fef2f2;
  --error-border: #fecaca;

  --warning: #f59e0b;
  --warning-light: #fffbeb;
  --warning-border: #fef3c7;

  --text-main: #0f172a;
  --text-muted: #64748b;

  --border-color: #f1f5f9;
  --border-light: #f8fafc;

  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05);

  --border-radius-lg: 16px;
  --border-radius-md: 12px;
  --border-radius-sm: 8px;

  --font-sans: Arial, sans-serif;
  --font-display: Arial, sans-serif;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-sans);
  background-color: var(--bg-page);
  color: var(--text-main);
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(253, 97, 1, 0.45);
}

/* Layout App Container */
.app {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--bg-page);
}

/* ==========================================================================
   NEO-MINIMALIST FLOATING CARD SIDEBAR (MATCHING DESIGN MOCKUP)
   Off-white floating shell, dark active pill buttons, elevated white active cards,
   and vertical tree guide lines.
   ========================================================================== */

.sidebar,
.modern-sidebar {
  width: 250px;
  background-color: #f0f2f5 !important;
  color: #1e293b !important;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 24px);
  margin: 12px 0 12px 14px;
  border-radius: 28px !important;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;
  flex-shrink: 0;
  padding: 20px 14px;
  overflow: hidden !important;
  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s ease, margin 0.35s ease !important;
  box-sizing: border-box;
}

/* Animated Collapsed Sidebar */
.modern-sidebar,
.sidebar {
  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin 0.35s ease !important;
}

.modern-sidebar.collapsed,
.sidebar.collapsed {
  width: 78px !important;
  min-width: 78px !important;
  padding: 20px 8px !important;
  overflow: visible !important;
}

.modern-sidebar.collapsed .sidebar-nav {
  overflow-y: visible !important;
  overflow-x: visible !important;
}

.modern-sidebar.collapsed .sidebar-logo {
  justify-content: center !important;
  padding-left: 0 !important;
  gap: 0 !important;
}

.modern-sidebar.collapsed .menu-group {
  position: relative;
}

.modern-sidebar.collapsed .parent-menu-item {
  justify-content: center !important;
  padding: 10px 0 !important;
  width: 48px !important;
  height: 44px !important;
  margin: 0 auto !important;
  border-radius: 16px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-sidebar.collapsed .parent-menu-item span {
  display: none !important;
}

.modern-sidebar.collapsed .menu-item-left {
  justify-content: center !important;
  gap: 0 !important;
}

.modern-sidebar.collapsed .parent-menu-item>span.toggle-icon {
  display: none !important;
}

.modern-sidebar.collapsed .sub-menu-tree {
  margin-left: 0 !important;
  padding-left: 0 !important;
  border-left: none !important;
  align-items: center !important;
  gap: 6px !important;
}

.modern-sidebar.collapsed .sub-menu-item {
  justify-content: center !important;
  width: 44px !important;
  height: 40px !important;
  padding: 0 !important;
  border-radius: 12px !important;
  margin: 0 auto !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-sidebar.collapsed .sub-menu-item span.sub-menu-text,
.modern-sidebar.collapsed .sub-menu-item span.dot-bullet,
.modern-sidebar.collapsed .menu-badge {
  display: none !important;
}

.sub-menu-item svg {
  flex-shrink: 0;
}

.modern-sidebar.collapsed .sub-menu-item svg {
  display: block !important;
}

.modern-sidebar.collapsed .sub-menu-item:hover {
  background: #f1f5f9 !important;
}

.modern-sidebar.collapsed .sub-menu-item:hover svg {
  transform: scale(1.15);
}

/* Collapsed Sidebar Floating Flyout Popover Menu */
.sidebar-flyout-menu {
  position: absolute;
  left: 64px;
  top: 0;
  width: 220px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.18), 0 4px 12px rgba(15, 23, 42, 0.08);
  padding: 10px;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-8px) scale(0.95);
  transition: opacity 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.2s;
  pointer-events: none;
}

.modern-sidebar.collapsed .menu-group:hover .sidebar-flyout-menu {
  opacity: 1;
  visibility: visible;
  transform: translateX(0) scale(1);
  pointer-events: auto;
}

.sidebar-flyout-menu .flyout-header {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #FD6101;
  padding: 4px 8px 8px 8px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 6px;
}

.sidebar-flyout-menu .flyout-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Collapsed Sidebar Hover Tooltips for Submodules & Items */
.modern-sidebar.collapsed .sub-menu-item[data-tooltip],
.modern-sidebar.collapsed .parent-menu-item[data-tooltip] {
  position: relative;
}

.modern-sidebar.collapsed .sub-menu-item[data-tooltip]::after,
.modern-sidebar.collapsed .parent-menu-item[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  left: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%) scale(0.92);
  background: #0f172a;
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s;
  z-index: 100001;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.25);
}

.modern-sidebar.collapsed .sub-menu-item[data-tooltip]::before,
.modern-sidebar.collapsed .parent-menu-item[data-tooltip]::before {
  content: "";
  position: absolute;
  left: calc(100% + 6px);
  top: 50%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #0f172a transparent transparent;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, visibility 0.18s;
  z-index: 100001;
}

.modern-sidebar.collapsed .sub-menu-item[data-tooltip]:hover::after,
.modern-sidebar.collapsed .parent-menu-item[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
}

.modern-sidebar.collapsed .sub-menu-item[data-tooltip]:hover::before,
.modern-sidebar.collapsed .parent-menu-item[data-tooltip]:hover::before {
  opacity: 1;
  visibility: visible;
}

.sidebar-flyout-menu .flyout-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #334155;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all 0.15s ease;
}

.sidebar-flyout-menu .flyout-item:hover {
  background: #f8fafc;
  color: #0f172a;
  transform: translateX(2px);
}

.sidebar-flyout-menu .flyout-item.active {
  background: #f1f5f9;
  color: #FD6101;
  font-weight: 700;
}

.sidebar-toggle-btn {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.sidebar-toggle-btn:hover {
  background: #FD6101;
  color: #ffffff;
  border-color: #FD6101;
  box-shadow: 0 4px 14px rgba(253, 97, 1, 0.35);
  transform: scale(1.08);
}

/* Sidebar Brand Header */
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
  padding-left: 6px;
}

.brand-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
}

.brand-title {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.4px;
}

/* Navigation Tree Wrapper */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sidebar-section-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin: 16px 0 6px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar-section-label::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e2e8f0;
  margin-right: 8px;
}

.menu-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 6px;
}

/* Parent Level Menu Item */
.parent-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  border-radius: 20px;
  border: none;
  background: transparent;
  color: #334155;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.parent-menu-item:hover {
  background: rgba(255, 255, 255, 0.7);
  color: #0f172a;
}

.parent-menu-item.active-black {
  background: #FD6101 !important;
  color: #ffffff !important;
  font-weight: 700;
  box-shadow: 0 6px 18px rgba(253, 97, 1, 0.3) !important;
}

.parent-menu-item.active-black:hover {
  background: #e05300 !important;
  box-shadow: 0 6px 20px rgba(224, 83, 0, 0.35) !important;
}

.parent-menu-item.active-black svg {
  stroke: #ffffff !important;
}

.menu-item-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toggle-icon {
  font-size: 15px;
  font-weight: 700;
  opacity: 0.7;
}

/* Vertical Connector Guide Line Tree Structure */
.sub-menu-tree {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 20px;
  padding-left: 12px;
  border-left: 2px solid #cbd5e1;
  margin-top: 2px;
  margin-bottom: 6px;
}

.sub-group-header {
  font-size: 11.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 10px 0 4px 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.nested-sub-menu {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-left: 4px;
}

/* Sub-menu Item Button */
.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 16px;
  border: 1px solid transparent;
  background: transparent;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.sub-menu-item:hover {
  background: rgba(255, 255, 255, 0.6);
  color: #0f172a;
}

/* Elevated Pure White Floating Active Card */
.sub-menu-item.active-white {
  background: #ffffff !important;
  color: #0f172a !important;
  font-weight: 700 !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.03) !important;
}

.sub-menu-item.active-white svg {
  stroke: #0f172a !important;
}

/* Dark Pill Count Badge */
.menu-badge {
  margin-left: auto;
  font-size: 11px;
  font-weight: 800;
  padding: 2px 7px;
  border-radius: 99px;
}

.menu-badge.dark {
  background: #0f172a;
  color: #ffffff;
}

/* Main Area Container */
.main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* Header Navbar - Curvy elevated floating card */
.main-header {
  height: 72px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  margin: 12px 24px 8px 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
  position: relative;
  z-index: 1000;
  transition: all 0.25s ease;
}

.header-welcome h1 {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  color: var(--text-main);
}

.header-welcome p {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: 2px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.btn-new-project {
  background-color: var(--primary);
  color: #ffffff;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: var(--border-radius-sm);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
}

.btn-new-project:hover {
  background-color: var(--primary-hover);
}

.header-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.header-icon-btn:hover {
  background-color: #f1f5f9;
  color: var(--text-main);
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: var(--border-radius-sm);
  transition: background-color 0.2s ease;
}

.user-profile:hover {
  background-color: #f1f5f9;
}

.avatar-badge {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #d1fae5;
  color: var(--primary);
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-details {
  text-align: left;
}

.profile-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
}

.profile-role {
  font-size: 11px;
  color: var(--text-muted);
}

/* Scrollable Inner Content Area */
.main-content {
  flex: 1 1;
  padding: 12px 24px 24px 16px;
  overflow-y: auto;
  background-color: var(--bg-page);
}

/* 5-Card Dashboard Metrics Grid */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.metric-card {
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: var(--border-radius-md);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease, border-color 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 16px 36px rgba(253, 97, 1, 0.15), 0 4px 12px rgba(0, 0, 0, 0.02);
  border-color: #FD6101;
  background: #fff7ed;
}

.metric-card:nth-child(1),
.metric-card:nth-child(2),
.metric-card:nth-child(3),
.metric-card:nth-child(4),
.metric-card:nth-child(5),
.metric-card:nth-child(6) {
  background: #ffffff;
}


.metric-info {
  display: flex;
  flex-direction: column;
}

.metric-label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 6px;
}

.metric-value {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-main);
  font-family: var(--font-display);
}

.metric-trend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 6px;
}

.metric-trend.up {
  color: var(--primary);
}

.metric-trend.down {
  color: var(--error);
}

.metric-icon-wrapper {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: var(--text-main);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  flex-shrink: 0;
}

/* Two-column layout: Create section and Activity */
.mid-section-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

/* Main creation/how-to card container */
.create-panel {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
}

.panel-header-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  color: var(--text-main);
}

.panel-header-subtitle {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: 4px;
  margin-bottom: 20px;
}

/* The 4 large interactive widgets */
.creation-cards-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.creation-card {
  border: 1px solid #cbd5e1;
  border-radius: var(--border-radius-md);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
  transition: all 0.2s ease;
  cursor: pointer;
  background-color: #ffffff;
}

.creation-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.creation-card.rec:hover {
  border-color: #ef4444;
  background-color: #fee2e2;
}

.creation-card.url:hover {
  border-color: #10b981;
  background-color: #d1fae5;
}

.creation-card.img:hover {
  border-color: #085ed1;
  background-color: #dbeafe;
}

.creation-card.prompt:hover {
  border-color: #f59e0b;
  background-color: #fef3c7;
}

.creation-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.creation-badge.rec {
  background-color: #fee2e2;
  color: #ef4444;
}

.creation-badge.url {
  background-color: #d1fae5;
  color: #059669;
}

.creation-badge.img {
  background-color: #dbeafe;
  color: #085ed1;
}

.creation-badge.prompt {
  background-color: #fef3c7;
  color: #d97706;
}

.creation-icon-graphic {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  border-radius: var(--border-radius-sm);
  margin-bottom: 12px;
  border: 1px dashed #cbd5e1;
}

.creation-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 6px;
}

.creation-desc {
  font-size: 11px;
  color: var(--text-muted);
  line-height: 1.4;
  margin-bottom: 16px;
  min-height: 48px;
}

.creation-card-btn {
  width: 100%;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: var(--border-radius-sm);
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.creation-card-btn.rec {
  border: 1px solid #f87171;
  color: #ef4444;
}

.creation-card-btn.rec:hover {
  background-color: #ef4444;
  color: white;
}

.creation-card-btn.url {
  border: 1px solid #34d399;
  color: #059669;
}

.creation-card-btn.url:hover {
  background-color: #059669;
  color: white;
}

.creation-card-btn.img {
  border: 1px solid #60a5fa;
  color: #085ed1;
}

.creation-card-btn.img:hover {
  background-color: #085ed1;
  color: white;
}

.creation-card-btn.prompt {
  border: 1px solid #fbbf24;
  color: #d97706;
}

.creation-card-btn.prompt:hover {
  background-color: #FFD700;
  color: white;
}

/* Activity panel */
.activity-panel {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-lg);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  text-align: left;
}

.panel-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.panel-link {
  font-size: 11px;
  font-weight: 600;
  color: var(--primary);
  background: transparent;
  border: 1.5px solid var(--primary);
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background 0.15s, color 0.15s;
  line-height: 1;
}

.panel-link:hover {
  background: var(--primary);
  color: #ffffff;
  text-decoration: none;
}

/* Activity Timeline items */
.activity-timeline {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
}

.activity-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.activity-icon-bullet {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.activity-icon-bullet.success {
  background-color: #ecfdf5;
  color: #10b981;
}

.activity-icon-bullet.danger {
  background-color: #fef2f2;
  color: #ef4444;
}

.activity-icon-bullet.primary {
  background-color: #ecfdf5;
  color: #10b981;
}

.activity-icon-bullet.blue {
  background-color: #eff6ff;
  color: #3b82f6;
}

.activity-details {
  flex-grow: 1;
  text-align: left;
}

.activity-title-text {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-main);
}

.activity-desc-text {
  font-size: 11.5px;
  color: var(--text-muted);
  margin-top: 2px;
}

.activity-time-stamp {
  font-size: 10px;
  color: var(--text-muted);
  white-space: nowrap;
}

/* Lower Section: execution summary, test runs list, top bugs */
.bottom-section-grid {
  display: grid;
  grid-template-columns: 1.2fr 1.6fr 1.6fr;
  gap: 20px;
  margin-bottom: 24px;
}

.summary-card {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-lg);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  text-align: left;
}

/* Donut Chart visual styles */
.donut-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
}

.donut-graphic {
  position: relative;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.donut-inner-white {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.05);
}

.donut-number {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-main);
  font-family: var(--font-display);
}

.donut-label {
  font-size: 10px;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

/* Summary Legend List */
.legend-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11.5px;
}

.legend-label-block {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-muted);
}

.legend-color-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.legend-color-dot.passed {
  background-color: var(--success);
}

.legend-color-dot.failed {
  background-color: var(--error);
}

.legend-color-dot.skipped {
  background-color: var(--warning);
}

.legend-color-dot.inprogress {
  background-color: var(--primary);
}

.legend-val {
  font-weight: 600;
  color: var(--text-main);
}

/* Secondary statistics below legend */
.summary-sub-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #f1f5f9;
  padding-top: 12px;
  margin-top: 16px;
  gap: 12px;
}

.sub-stat-block {
  display: flex;
  flex-direction: column;
}

.sub-stat-title {
  font-size: 11px;
  color: var(--text-muted);
  margin-bottom: 2px;
}

.sub-stat-number {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-main);
}

.sub-stat-trend {
  font-size: 10px;
  font-weight: 600;
  margin-top: 2px;
}

.sub-stat-trend.up {
  color: var(--success);
}

.sub-stat-trend.down {
  color: var(--error);
}

/* Table and Lists within Cards */
.recent-runs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.run-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: var(--border-radius-sm);
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
}

.run-item-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.run-name-text {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-main);
}

.run-time-text {
  font-size: 10.5px;
  color: var(--text-muted);
  margin-top: 2px;
}

.run-status-pill {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
}

.run-status-pill.passed {
  background-color: #d1fae5;
  color: #059669;
}

.run-status-pill.failed {
  background-color: #fee2e2;
  color: #ef4444;
}

.run-status-pill.inprogress {
  background-color: #ecfdf5;
  color: #10b981;
}

.run-duration {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--text-main);
  font-family: monospace;
}

/* Bugs List styling */
.bugs-list-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bug-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: var(--border-radius-sm);
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
}

.bug-info-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.bug-code-id {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-muted);
}

.bug-title-name {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-main);
}

.bug-badge-pills {
  display: flex;
  align-items: center;
  gap: 6px;
}

.bug-pill {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
}

.bug-pill.priority-high {
  background-color: #fef2f2;
  color: #ef4444;
}

.bug-pill.priority-medium {
  background-color: #fffbeb;
  color: #d97706;
}

.bug-pill.priority-low {
  background-color: #eff6ff;
  color: #FD6101;
}

.bug-pill.status-new {
  background-color: #f1f5f9;
  color: #475569;
}

.bug-pill.status-inprogress {
  background-color: #fffbeb;
  color: #d97706;
}

.bug-pill.status-resolved {
  background-color: #ecfdf5;
  color: #10b981;
}

/* Bottom Projects Grid & Help Row */
.bottom-projects-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

/* General clean Table Styling */
.table-card {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-lg);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  overflow-x: auto;
  text-align: left;
}

.projects-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}

.projects-table th {
  font-size: 11.5px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.projects-table td {
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
  color: var(--text-main);
  text-align: left;
}

.projects-table tr:last-child td {
  border-bottom: none;
}

.projects-table tr:hover td {
  background-color: #fafbfc;
}

.project-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.project-icon {
  color: var(--primary);
  display: flex;
  align-items: center;
}

.table-status-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  display: inline-block;
}

.table-status-badge.healthy {
  background-color: #d1fae5;
  color: #059669;
}

.table-status-badge.risk {
  background-color: #fef3c7;
  color: #d97706;
}

.table-action-btns {
  display: flex;
  gap: 6px;
}

.table-row-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.table-row-btn:hover {
  background-color: #f1f5f9;
  color: var(--text-main);
}

/* Help Resources Panel styling */
.help-panel {
  background: #002247;
  color: white;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: var(--shadow-sm);
  text-align: left;
  transition: all 0.25s ease;
}

.help-panel:hover {
  background: #FD6101;
  transform: translateY(-2px);
}

.help-panel h3 {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 8px;
}

.help-panel p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  margin-bottom: 16px;
}

.help-links-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.help-link-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #000000;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.help-link-item:hover {
  color: #FD6101;
}

.btn-help-explore {
  background-color: #ffffff;
  color: var(--primary-hover);
  border: none;
  border-radius: var(--border-radius-sm);
  padding: 10px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease;
}

.btn-help-explore:hover {
  background-color: #f1f5f9;
}

/* ------------------- GENERATOR PAGE REDESIGN ------------------- */
.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider.round {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: .3s;
  border-radius: 34px;
}

.slider.round:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.switch input:checked+.slider.round:before {
  transform: translateX(18px);
}

.gen-url-credential-bar {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-md);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  margin-bottom: 20px;
  text-align: left;
}

.gen-url-credential-bar label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.gen-input {
  width: 100%;
  padding: 11px 14px;
  border-radius: var(--border-radius-sm);
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: var(--text-main);
  outline: none;
  font-size: 13.5px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.gen-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
}

.gen-textarea {
  width: 100%;
  min-height: 140px;
  padding: 14px;
  border-radius: var(--border-radius-md);
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: var(--text-main);
  outline: none;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.gen-textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
}

/* Interactive tab selections in Generator Page */
.gen-tabs-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.gen-tab {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-md);
  padding: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: var(--shadow-sm);
}

.gen-tab.active {
  border-color: var(--primary);
  background-color: rgba(16, 185, 129, 0.03);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.gen-tab.record.active {
  border-color: #ef4444;
  background-color: rgba(239, 68, 68, 0.03);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.gen-tab.record.active svg {
  color: #ef4444;
}

.gen-tab.record.active .gen-tab-label {
  color: #ef4444;
}

.gen-tab.url.active {
  border-color: var(--primary);
  background-color: rgba(16, 185, 129, 0.03);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.gen-tab.url.active svg {
  color: var(--primary);
}

.gen-tab.url.active .gen-tab-label {
  color: var(--primary);
}

.gen-tab.screenshots.active {
  border-color: #FD6101;
  background-color: rgba(37, 99, 235, 0.03);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.gen-tab.screenshots.active svg {
  color: #FD6101;
}

.gen-tab.screenshots.active .gen-tab-label {
  color: #FD6101;
}

.gen-tab.prompt.active {
  border-color: #FFD700;
  background-color: rgba(234, 179, 8, 0.03);
  box-shadow: 0 0 0 3px rgba(234, 179, 8, 0.1);
}

.gen-tab.prompt.active svg {
  color: #FFD700;
}

.gen-tab.prompt.active .gen-tab-label {
  color: #FFD700;
}

.gen-tab svg {
  width: 22px;
  height: 22px;
  color: var(--text-muted);
}

.gen-tab.active svg {
  color: var(--primary);
}

.gen-tab-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
}

.gen-tab.active .gen-tab-label {
  color: var(--primary);
}

/* Code Editor Card visual wrappers */
.code-card {
  background-color: #0f172a;
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--primary);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  text-align: left;
}

.code-card-header {
  background-color: #1e293b;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #334155;
}

.code-card-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #f8fafc;
  display: flex;
  align-items: center;
  gap: 8px;
}

.code-card pre {
  margin: 0;
  padding: 20px;
  background-color: #0b0f19;
  color: #ffffff;
  /* White syntax code highlight! */
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;
  font-size: 12.5px;
  line-height: 1.7;
  overflow-x: auto;
  min-height: 200px;
  max-height: 400px;
  text-align: left;
}

/* Clean UI checklist table */
.checklist-card {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
}

/* Interactive Action Buttons Row */
.action-bar-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
  border: none;
  padding: 11px 22px;
  font-weight: 600;
  font-size: 13.5px;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
}

.btn-primary:hover {
  background-color: var(--primary-hover);
}

.btn-secondary {
  background-color: #ffffff;
  color: var(--text-main);
  border: 1px solid #e2e8f0;
  padding: 11px 22px;
  font-weight: 600;
  font-size: 13.5px;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.btn-danger {
  background-color: #fee2e2;
  color: #ef4444;
  border: 1px solid #fecaca;
  padding: 11px 22px;
  font-weight: 600;
  font-size: 13.5px;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-danger:hover {
  background-color: #ef4444;
  color: white;
  border-color: #ef4444;
}

.gen-select {
  padding: 11px 14px;
  border-radius: var(--border-radius-sm);
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  color: var(--text-main);
  font-size: 13.5px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.gen-select:focus {
  border-color: var(--primary);
}

/* ------------------- TEST CASES PAGE REDESIGN ------------------- */
.repo-grid {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 24px;
}

.repo-sidebar {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-lg);
  padding: 20px;
  height: fit-content;
  box-shadow: var(--shadow-sm);
  text-align: left;
}

.repo-sidebar-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;
}

.project-list-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--border-radius-sm);
  border: 1px solid #f1f5f9;
  background-color: #ffffff;
  cursor: pointer;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-main);
  text-align: left;
}

.project-list-btn:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.project-list-btn.active {
  background-color: var(--primary-light);
  border-color: var(--primary);
  color: var(--primary-hover);
  font-weight: 600;
}

.project-list-btn-badge {
  font-size: 10.5px;
  font-weight: 600;
  background-color: #f1f5f9;
  padding: 2px 6px;
  border-radius: 10px;
  color: var(--text-muted);
}

.project-list-btn.active .project-list-btn-badge {
  background-color: #ffffff;
  color: var(--primary-hover);
}

.repo-content-pane {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.repo-tc-card {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-md);
  padding: 18px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: border-color 0.2s ease;
}

.repo-tc-card:hover {
  border-color: var(--primary-light);
}

.repo-tc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.repo-tc-title-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--text-main);
  cursor: pointer;
  text-align: left;
}

.repo-tc-checkbox {
  width: 17px;
  height: 17px;
  cursor: pointer;
  accent-color: var(--primary);
}

.repo-tc-action-bar {
  display: flex;
  gap: 8px;
}

.repo-tc-action-btn {
  padding: 6px 12px;
  font-size: 11.5px;
  font-weight: 600;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.repo-tc-action-btn.view {
  background-color: #f1f5f9;
  color: var(--text-main);
  border: 1px solid #cbd5e1;
}

.repo-tc-action-btn.view:hover {
  background-color: #e2e8f0;
}

.repo-tc-action-btn.run {
  background-color: var(--success);
  color: white;
}

.repo-tc-action-btn.run:hover {
  background-color: #059669;
}

.repo-tc-action-btn.delete {
  background-color: #fee2e2;
  color: #ef4444;
  border: 1px solid #fecaca;
}

.repo-tc-action-btn.delete:hover {
  background-color: #ef4444;
  color: white;
  border-color: #ef4444;
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 10005;
  padding: clamp(12px, 3vh, 28px) clamp(8px, 2.5vw, 20px);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.modal-card {
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 44px);
  background-color: #ffffff;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-lg);
  border: 1px solid #f1f5f9;
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  margin: auto 0;
  position: relative;
}

/* Modal action footer sticky pinned to bottom so Save/Cancel are always visible */
.modal-card>div:last-child,
.modal-actions,
.modal-footer {
  position: sticky;
  bottom: -24px;
  background: #ffffff;
  padding-top: 14px;
  padding-bottom: 4px;
  margin-top: auto;
  border-top: 1px solid #f1f5f9;
  z-index: 10;
  flex-shrink: 0;
}

.modal-title {
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 16px;
}

.modal-input-group {
  margin-bottom: 20px;
}

.modal-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 6px;
}

/* ------------------- ANALYTICS / MOCK PAGES STYLES ------------------- */
.insights-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.insight-metric-card {
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-md);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
}

.insight-graph-bar {
  height: 8px;
  background-color: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 12px;
}

.insight-graph-fill {
  height: 100%;
  background-color: var(--primary);
  border-radius: 4px;
}

/* ==========================================================================
   PREMIUM INTERACTIVE UPGRADE STYLES (Rabbit)
   ========================================================================== */

/* 1. Live Step Runner Timeline */
.live-runner-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
  margin-top: 16px;
}

.live-timeline {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  padding-left: 32px;
  margin-top: 20px;
}

.live-timeline::before {
  content: "";
  position: absolute;
  left: 11px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background-color: #f1f5f9;
}

.live-timeline-step {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  transition: all 0.3s ease;
}

.live-timeline-bullet {
  position: absolute;
  left: -32px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.live-timeline-step.completed .live-timeline-bullet {
  background-color: var(--success);
  border-color: var(--success);
  color: #ffffff;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.3);
}

.live-timeline-step.active .live-timeline-bullet {
  background-color: #ffffff;
  border-color: var(--primary);
  color: var(--primary);
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15);
  animation: pulse-border 1.5s infinite alternate;
}

.live-timeline-step.failed .live-timeline-bullet {
  background-color: var(--error);
  border-color: var(--error);
  color: #ffffff;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.3);
}

.live-timeline-step.skipped .live-timeline-bullet {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  color: #94a3b8;
}

.live-timeline-content {
  display: flex;
  flex-direction: column;
}

.live-timeline-label {
  font-size: 13.5px;
  font-weight: 600;
  color: #64748b;
  transition: color 0.3s ease;
}

.live-timeline-step.active .live-timeline-label {
  color: var(--text-main);
  font-weight: 700;
}

.live-timeline-step.completed .live-timeline-label {
  color: var(--text-main);
}

.live-timeline-step.failed .live-timeline-label {
  color: var(--error);
  font-weight: 700;
}

@keyframes pulse-border {
  from {
    box-shadow: 0 0 0 0px rgba(16, 185, 129, 0.3);
  }

  to {
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.15);
  }
}

/* 2. Visual Regression Split Screen Slider */
.visual-slider-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
  margin-top: 16px;
}

.slider-wrapper {
  position: relative;
  width: 100%;
  height: 300px;
  border-radius: var(--border-radius-md);
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  cursor: ew-resize;
  border: 1px solid #cbd5e1;
  box-shadow: var(--shadow-md);
}

.slider-panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-panel-content {
  width: 100%;
  height: 100%;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.slider-bar-divider {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 10;
  pointer-events: none;
}

.slider-drag-handle {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--primary);
  border: 3px solid #ffffff;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  cursor: ew-resize;
  z-index: 11;
  pointer-events: none;
  font-size: 14px;
}

/* Mock Dashboard Previews inside Slider */
.mock-app-header {
  height: 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-radius: 6px 6px 0 0;
}

.mock-app-body {
  flex-grow: 1;
  background-color: #ffffff;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mock-app-button {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  border: none;
  cursor: pointer;
  align-self: flex-start;
  transition: all 0.2s;
}

.mock-app-button.expected {
  background-color: var(--success);
  color: white;
}

.mock-app-button.actual {
  background-color: var(--error);
  color: white;
  position: relative;
  animation: visual-mismatch-shake 0.8s infinite alternate;
}

@keyframes visual-mismatch-shake {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(8px);
  }
}

.visual-regression-label-badge {
  position: absolute;
  top: 10px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ffffff;
  z-index: 5;
  box-shadow: var(--shadow-sm);
}

.visual-regression-label-badge.expected {
  left: 10px;
  background-color: var(--success);
}

.visual-regression-label-badge.actual {
  right: 10px;
  background-color: var(--error);
}

/* 3. Locator Health Heatmap */
.health-heatmap-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  text-align: left;
  margin-top: 24px;
}

.heatmap-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 16px;
}

.heatmap-cell {
  border-radius: var(--border-radius-sm);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 90px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
  position: relative;
}

.heatmap-cell:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: var(--shadow-md);
  z-index: 10;
}

.heatmap-cell.healthy {
  background-color: rgba(16, 185, 129, 0.08);
  border-color: rgba(16, 185, 129, 0.15);
  color: #065f46;
}

.heatmap-cell.brittle {
  background-color: rgba(245, 158, 11, 0.08);
  border-color: rgba(245, 158, 11, 0.15);
  color: #92400e;
}

.heatmap-cell.flaky {
  background-color: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.15);
  color: #991b1b;
}

.heatmap-cell-title {
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
  word-break: break-all;
}

.heatmap-cell-status {
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}

.heatmap-popover {
  background: #0f172a;
  color: #f8fafc;
  border-radius: var(--border-radius-md);
  padding: 16px;
  margin-top: 16px;
  box-shadow: var(--shadow-lg);
  border: 1px solid #334155;
  animation: slide-up 0.2s ease-out;
}

@keyframes slide-up {
  from {
    transform: translateY(10px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 4. Low-Code Scenario Builder */
.builder-canvas {
  background-color: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: var(--border-radius-md);
  padding: 20px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}

.builder-step-row {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius-sm);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: var(--shadow-sm);
  animation: step-fade-in 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes step-fade-in {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.builder-step-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--primary-light);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
}

.builder-step-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 4px;
  background-color: #cbd5e1;
  color: #334155;
}

.builder-step-badge.navigate {
  background-color: #eff6ff;
  color: #FD6101;
}

.builder-step-badge.type {
  background-color: #f0fdf4;
  color: #166534;
}

.builder-step-badge.click {
  background-color: #fef2f2;
  color: #991b1b;
}

.builder-step-badge.assert {
  background-color: #faf5ff;
  color: #6b21a8;
}

/* Dynamic Bouncing Dots Loader */
.loader {
  display: flex;
  align-items: center;
  gap: 5px;
}

.loader-dot {
  width: 8px;
  height: 8px;
  background-color: #10b981;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loader-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loader-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.0);
  }
}

/* 1. Pulse Loader for Button Text */
.pulse-loader {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: currentColor;
  border-radius: 50%;
  animation: pulse 1.2s infinite ease-in-out;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes pulse {
  0% {
    transform: scale(0.6);
    opacity: 0.6;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(0.6);
    opacity: 0.6;
  }
}

/* 2. Premium Ring Loader for Small Spinners */
.ring-loader {
  width: 14px;
  height: 14px;
  border: 2px solid var(--primary-light);
  border-top: 2px solid var(--primary);
  border-radius: 50%;
  animation: spin 0.8s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;
  display: inline-block;
  vertical-align: middle;
}

.ring-loader.white {
  border-color: rgba(255, 255, 255, 0.2);
  border-top-color: #ffffff;
}

/* 3. Line Scale Loader for Datasets */
.line-scale-loader {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
}

.line-scale-loader div {
  width: 3px;
  height: 15px;
  background-color: var(--primary);
  animation: line-scale 1.2s infinite ease-in-out;
}

.line-scale-loader div:nth-child(1) {
  animation-delay: -1.2s;
}

.line-scale-loader div:nth-child(2) {
  animation-delay: -1.1s;
}

.line-scale-loader div:nth-child(3) {
  animation-delay: -1s;
}

.line-scale-loader div:nth-child(4) {
  animation-delay: -0.9s;
}

.line-scale-loader div:nth-child(5) {
  animation-delay: -0.8s;
}

@keyframes line-scale {

  0%,
  40%,
  100% {
    transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1);
  }
}

/* Sidebar Tree Lines layout */
.sidebar-menu-group-list {
  position: relative;
  padding-left: 14px;
  margin-left: 6px;
  border-left: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 6px;
  margin-bottom: 12px;
}

.sidebar-menu-group-list .sidebar-menu-btn {
  position: relative;
  margin-bottom: 2px;
  padding-left: 12px;
}

.sidebar-menu-group-list .sidebar-menu-btn::before {
  content: '';
  position: absolute;
  left: -14px;
  top: 50%;
  width: 10px;
  height: 1px;
  background-color: #e2e8f0;
}

/* Header widgets */
.header-widgets-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  justify-content: center;
  padding: 0 16px;
  min-width: 0;
}

.header-widget-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: var(--border-radius-md);
  padding: 8px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
  flex-shrink: 0;
}

.header-widget-pill:hover {
  background-color: #f1f5f9;
  border-color: #e2e8f0;
}

.header-widget-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}

.cron-sync-icon svg {
  animation: none;
}

.cron-sync-icon:hover svg {
  animation: spin-sync 2s linear infinite;
}

@keyframes spin-sync {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.live-clock-pill:hover .header-widget-icon svg {
  animation: clock-wiggle 0.5s ease-in-out infinite alternate;
}

@keyframes clock-wiggle {
  from {
    transform: rotate(-8deg);
  }

  to {
    transform: rotate(8deg);
  }
}

.header-widget-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.header-widget-title {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-muted);
  line-height: 1.2;
}

.header-widget-desc {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-main);
  display: flex;
  align-items: center;
  gap: 5px;
  line-height: 1.3;
}

.status-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-dot.green {
  background-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
}

.header-widget-chevron {
  display: flex;
  align-items: center;
  color: var(--text-muted);
  margin-left: 4px;
}

.header-action-circle-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.header-action-circle-btn:hover {
  background-color: #f8fafc;
  color: var(--text-main);
  border-color: #e2e8f0;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.avatar-badge {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  /* square-like rounded corner from mockup */
  background-color: #fff7ed;
  color: var(--primary);
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Segmented circular gauge styling */
.test-summary-layout {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.gauge-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.gauge-legend-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}

.gauge-legend-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gauge-legend-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
}

.gauge-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.gauge-legend-dot.passed {
  background-color: var(--success);
}

.gauge-legend-dot.failed {
  background-color: var(--error);
}

.gauge-legend-val {
  font-size: 12px;
  color: var(--text-muted);
  padding-left: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.trend-arrow-up {
  color: var(--success);
  font-weight: 700;
}

.trend-arrow-down {
  color: var(--error);
  font-weight: 700;
}

/* ==========================================================================
   MANUAL TEST CASES & GOOGLE SHEETS SYNC STYLES
   ========================================================================== */

.manual-grid {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 24px;
  margin-top: 16px;
  align-items: start;
}

.manual-sidebar {
  background: var(--bg-card);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: var(--border-radius-md);
  padding: 16px;
  min-height: 400px;
}

.manual-sidebar-title {
  font-family: var(--font-display);
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: var(--text-main);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.manual-project-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: var(--border-radius-sm);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-main);
  width: 100%;
  margin-bottom: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  text-align: left;
}

.manual-project-btn:hover {
  background: rgba(124, 92, 246, 0.05);
  transform: translateX(2px);
}

.manual-project-btn.active {
  background: var(--primary);
  color: #ffffff !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(124, 92, 246, 0.2);
}

.manual-project-btn.active .project-badge {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.project-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.05);
  color: var(--text-muted);
  font-weight: 700;
}

.manual-main-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.manual-metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.priority-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.priority-badge.high {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.priority-badge.medium {
  background-color: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.priority-badge.low {
  background-color: rgba(37, 99, 235, 0.1);
  color: #FD6101;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.passed {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.status-badge.failed {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.status-badge.blocked {
  background-color: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

.status-badge.untested {
  background-color: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

/* execution wizard styles */
.exec-wizard-container {
  background: var(--bg-card);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: var(--border-radius-md);
  padding: 24px;
  margin-top: 16px;
  box-shadow: var(--shadow-lg);
  animation: slideUp 0.3s ease;
}

.exec-wizard-header {
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.exec-step-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.exec-step-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: var(--border-radius-sm);
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.exec-step-row.completed {
  background: rgba(16, 185, 129, 0.04);
  border-color: rgba(16, 185, 129, 0.2);
}

.exec-step-row.failed {
  background: rgba(239, 68, 68, 0.04);
  border-color: rgba(239, 68, 68, 0.2);
}

.exec-step-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.step-number-pill {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.exec-step-actions {
  display: flex;
  gap: 8px;
}

.step-action-btn {
  padding: 6px 12px;
  border-radius: var(--border-radius-sm);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.15s ease;
}

.step-action-btn.pass {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.2);
}

.step-action-btn.pass:hover,
.step-action-btn.pass.active {
  background: #10b981;
  color: white;
}

.step-action-btn.fail {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.2);
}

.step-action-btn.fail:hover,
.step-action-btn.fail.active {
  background: #ef4444;
  color: white;
}

/* Google Sync Card styles */
.sync-card {
  background: #fff7ed;
  border: 1px dashed #FD6101;
  border-radius: var(--border-radius-md);
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
  transition: all 0.2s ease;
}

.sync-card:hover {
  background: #ffedd5;
  border-color: #e05300;
}

.sync-status-alert {
  padding: 12px 16px;
  border-radius: var(--border-radius-sm);
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
}

.sync-status-alert.configured {
  background: rgba(16, 185, 129, 0.08);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.sync-status-alert.missing {
  background: rgba(245, 158, 11, 0.08);
  color: #f59e0b;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.steps-list-preview {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: var(--text-main);
  line-height: 1.5;
}

.steps-list-preview li {
  margin-bottom: 4px;
}

/* Sidebar Submenu Dropdown */
.sidebar-dropdown-parent {
  position: relative;
  width: 100%;
}

.sidebar-dropdown-content {
  display: none;
  flex-direction: column;
  padding-left: 20px;
  margin-top: 4px;
  margin-bottom: 8px;
  border-left: 1px solid rgba(226, 232, 240, 0.4);
  margin-left: 14px;
  gap: 4px;
  animation: fadeIn 0.2s ease;
}

/* Hover or active behavior to show dropdown sub-items */
.sidebar-dropdown-parent:hover .sidebar-dropdown-content {
  display: flex;
}

.sidebar-dropdown-parent.active-parent .sidebar-dropdown-content {
  display: flex;
}

/* Styles for submenu buttons */
.sidebar-submenu-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: var(--border-radius-sm);
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
  width: calc(100% - 14px);
}

.sidebar-submenu-btn:hover {
  background: rgba(124, 92, 246, 0.05);
  color: var(--text-main);
}

.sidebar-submenu-btn.active {
  background: rgba(124, 92, 246, 0.1);
  color: var(--primary);
  font-weight: 600;
}

.sidebar-submenu-btn .bullet {
  font-size: 14px;
  opacity: 0.5;
}

.sidebar-submenu-btn.active .bullet {
  color: var(--primary);
  opacity: 1;
}

.dropdown-arrow {
  margin-left: auto;
  font-size: 10px;
  opacity: 0.6;
  transition: transform 0.2s ease;
}

.sidebar-dropdown-parent:hover .dropdown-arrow {
  transform: rotate(180deg);
}

/* Test case clickable links styling */
.tc-id-link {
  color: var(--primary);
  cursor: pointer;
  transition: color 0.2s ease, text-decoration 0.2s ease;
}

.tc-id-link:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

.tc-title-link {
  cursor: pointer;
  transition: color 0.2s ease;
}

.tc-title-link:hover {
  color: var(--primary);
}

/* Floating Run Selected button style */
.floating-run-selected {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #FD6101;
  color: #ffffff;
  padding: 14px 28px;
  border-radius: 50px;
  box-shadow: 0 10px 25px -5px rgba(253, 97, 1, 0.4), 0 8px 10px -6px rgba(253, 97, 1, 0.3);
  cursor: pointer;
  font-family: var(--font-display, sans-serif);
  font-weight: 700;
  font-size: 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: float-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.floating-run-selected:hover {
  transform: translateY(-4px) scale(1.03);
  box-shadow: 0 20px 30px -10px rgba(224, 83, 0, 0.5), 0 10px 15px -5px rgba(224, 83, 0, 0.4);
  background: #e05300;
}

.floating-run-selected:active {
  transform: translateY(-1px) scale(0.98);
  box-shadow: 0 5px 15px -3px rgba(253, 97, 1, 0.4);
  background: #c2410c;
}

.floating-run-selected.running {
  background: #dc2626;
  box-shadow: 0 10px 25px -5px rgba(220, 38, 38, 0.4), 0 8px 10px -6px rgba(220, 38, 38, 0.4);
}

.floating-run-selected.running:hover {
  background: #b91c1c;
  box-shadow: 0 20px 30px -10px rgba(220, 38, 38, 0.6), 0 10px 15px -5px rgba(220, 38, 38, 0.6);
}

@keyframes float-in {
  0% {
    transform: translateY(100px) scale(0.8);
    opacity: 0;
  }

  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* Global Execution Progress Banner styling */
.global-execution-banner {
  border-left: 5px solid var(--primary, #10b981) !important;
}

.global-execution-banner.failed {
  border-left: 5px solid #ef4444 !important;
}

.global-execution-banner.completed {
  border-left: 5px solid #10b981 !important;
}

@keyframes slide-up-banner {
  0% {
    transform: translateY(150px) scale(0.9);
    opacity: 0;
  }

  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes slide-in-toast {
  0% {
    transform: translateX(120%) scale(0.9);
    opacity: 0;
  }

  100% {
    transform: translateX(0) scale(1);
    opacity: 1;
  }
}

/* ==================================================== */
/* REDESIGNED CROSS-BROWSER VALIDATION MATRIX STYLES */
/* ==================================================== */

.matrix-section-container {
  margin: 24px 0;
  text-align: left;
  width: 100%;
}

.matrix-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: var(--shadow-sm);
}

.matrix-summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 16px;
  flex: 1 1;
}

.matrix-stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.matrix-stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  font-weight: 600;
}

.matrix-stat-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-main);
}

.matrix-stat-value.passed {
  color: var(--success);
}

.matrix-stat-value.failed {
  color: var(--error);
}

.matrix-stat-value.running {
  color: var(--warning);
}

.matrix-stat-value.queued {
  color: #3b82f6;
}

.matrix-overall-success {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 24px;
  border-left: 1px solid var(--border-color);
}

.matrix-progress-ring-container {
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.matrix-progress-ring-text {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-main);
}

.matrix-filter-section {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  box-shadow: var(--shadow-sm);
}

.matrix-search-input-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 250px;
}

.matrix-search-input {
  width: 100%;
  padding: 10px 16px 10px 38px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  background-color: var(--bg-page);
  font-size: 13px;
  color: var(--text-main);
  outline: none;
  transition: border-color 0.2s;
}

.matrix-search-input:focus {
  border-color: var(--primary);
}

.matrix-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.matrix-filters-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.matrix-select-filter {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  background-color: var(--bg-card);
  color: var(--text-main);
  font-size: 13px;
  outline: none;
  cursor: pointer;
}

.matrix-select-filter:focus {
  border-color: var(--primary);
}

.matrix-card-grid {
  display: grid;
  gap: 20px;
  margin-bottom: 24px;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
}

.matrix-project-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.matrix-project-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.matrix-card-header {
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
  background: #fafafa;
}

.matrix-card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.matrix-project-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-main);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.matrix-card-header-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  font-size: 11px;
  color: var(--text-muted);
  margin-bottom: 12px;
}

.matrix-header-stat-box {
  background: var(--bg-page);
  padding: 4px 6px;
  border-radius: var(--border-radius-sm);
  text-align: center;
  font-weight: 600;
}

.matrix-badge-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed var(--border-color);
  padding-top: 10px;
  font-size: 11px;
  color: var(--text-muted);
}

.matrix-badge-browser-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.matrix-tc-list-container {
  height: 350px;
  overflow-y: auto;
  position: relative;
}

/* Scrollbar styles */
.matrix-tc-list-container::-webkit-scrollbar {
  width: 6px;
}

.matrix-tc-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.matrix-tc-list-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.matrix-tc-list-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.matrix-tc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.matrix-tc-table th {
  position: sticky;
  top: 0;
  background: var(--bg-card);
  color: var(--text-muted);
  font-weight: 600;
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-color);
  z-index: 2;
}

.matrix-tc-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-color);
}

.matrix-tc-row {
  cursor: pointer;
  transition: background-color 0.15s;
}

.matrix-tc-row:hover {
  background-color: var(--bg-page);
}

.matrix-tc-name-cell {
  font-weight: 600;
  color: var(--text-main);
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Status Chips/Pills */
.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 8px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 12px;
  text-transform: uppercase;
}

.status-pill.pass {
  background-color: var(--success-light);
  color: var(--success);
  border: 1px solid var(--success-border);
}

.status-pill.fail {
  background-color: var(--error-light);
  color: var(--error);
  border: 1px solid var(--error-border);
}

.status-pill.running {
  background-color: var(--warning-light);
  color: var(--warning);
  border: 1px solid var(--warning-border);
}

.status-pill.queued {
  background-color: #eff6ff;
  color: #3b82f6;
  border: 1px solid #bfdbfe;
}

.status-pill.not-run {
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.matrix-card-footer {
  padding: 10px 16px;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: var(--bg-card);
  font-weight: 600;
  color: var(--primary);
  font-size: 12px;
  transition: background-color 0.2s;
}

.matrix-card-footer:hover {
  background-color: var(--primary-light);
}

/* Detail Modal Styles */
.matrix-detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  animation: fade-in 0.2s ease-out;
}

.matrix-detail-modal {
  background: var(--bg-card);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  width: 95%;
  max-width: 1100px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: scale-up 0.2s ease-out;
}

.matrix-detail-header {
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.matrix-detail-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
  display: flex;
  align-items: center;
  gap: 8px;
}

.matrix-detail-body {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

.matrix-detail-sidebar {
  width: 280px;
  border-right: 1px solid var(--border-color);
  overflow-y: auto;
  padding: 16px;
  background-color: #fafafa;
}

.matrix-detail-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--bg-page);
}

.matrix-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.matrix-detail-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  padding: 16px;
  box-shadow: var(--shadow-sm);
}

.matrix-detail-label {
  font-size: 11px;
  color: var(--text-muted);
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 4px;
}

.matrix-detail-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-main);
}

.matrix-log-viewer {
  background-color: #0f172a;
  color: #f8fafc;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 12px;
  padding: 16px;
  border-radius: var(--border-radius-md);
  height: 250px;
  overflow-y: auto;
  text-align: left;
  white-space: pre-wrap;
}

.matrix-history-item {
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  background: var(--bg-card);
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.matrix-history-item:hover {
  border-color: var(--primary);
  background-color: var(--primary-light);
}

.matrix-history-item.active {
  border-color: var(--primary);
  background-color: var(--primary-light);
  box-shadow: var(--shadow-sm);
}

.matrix-close-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 20px;
  cursor: pointer;
}

.matrix-close-btn:hover {
  color: var(--text-main);
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scale-up {
  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* ============================================================
   PIPELINE EXECUTION — Product Theme (Violet/Purple)
   ============================================================ */

/* Root container */
.jp-root {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  background: var(--bg-page);
  color: var(--text-main);
  font-family: var(--font-sans);
  overflow: hidden;
}

/* ---- TOP HEADER BAR ---- */
.jp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 56px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  gap: 16px;
  box-shadow: var(--shadow-sm);
}

.jp-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

.jp-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.jp-build-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.jp-build-number {
  font-size: 22px;
  font-weight: 800;
  color: var(--primary);
  letter-spacing: -0.5px;
}

.jp-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.jp-status-badge.running {
  background: var(--primary-light);
  color: var(--primary);
  border: 1px solid #c4b5fd;
}

.jp-status-badge.passed {
  background: var(--success-light);
  color: #047857;
  border: 1px solid var(--success-border);
}

.jp-status-badge.failed {
  background: var(--error-light);
  color: #b91c1c;
  border: 1px solid var(--error-border);
}

.jp-status-badge.pending {
  background: #f1f5f9;
  color: var(--text-muted);
  border: 1px solid #e2e8f0;
}

.jp-status-badge.completed {
  background: var(--success-light);
  color: #047857;
  border: 1px solid var(--success-border);
}

.jp-test-name {
  font-size: 13px;
  color: var(--text-main);
  font-family: 'Consolas', monospace;
  background: var(--bg-page);
  border: 1px solid var(--border-color);
  padding: 3px 10px;
  border-radius: 6px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jp-timer {
  font-size: 13px;
  color: var(--text-muted);
  font-family: monospace;
  background: var(--bg-page);
  border: 1px solid var(--border-color);
  padding: 3px 10px;
  border-radius: 6px;
}

.jp-triggered-by {
  font-size: 12px;
  color: var(--text-muted);
}

.jp-abort-btn {
  background: var(--error-light);
  border: 1px solid var(--error-border);
  color: var(--error);
  padding: 5px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.jp-abort-btn:hover {
  background: #fecaca;
  color: #b91c1c;
}

/* ---- PIPELINE STAGES ROW ---- */
.jp-stages-row {
  display: flex;
  align-items: stretch;
  padding: 14px 24px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  overflow-x: auto;
  gap: 0;
  box-shadow: var(--shadow-sm);
}

.jp-stage-wrapper {
  display: flex;
  align-items: center;
}

.jp-stage-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 112px;
  padding: 8px 14px;
  border-radius: var(--border-radius-sm);
  border: 1.5px solid var(--border-color);
  background: var(--bg-page);
  cursor: default;
  transition: all 0.25s;
  position: relative;
}

.jp-stage-block.completed {
  border-color: var(--success-border);
  background: var(--success-light);
}

.jp-stage-block.failed {
  border-color: var(--error-border);
  background: var(--error-light);
}

.jp-stage-block.running {
  border-color: #c4b5fd;
  background: var(--primary-light);
  animation: jp-pulse-border 1.4s ease-in-out infinite;
}

.jp-stage-block.skipped {
  border-color: #e2e8f0;
  background: #f8fafc;
  opacity: 0.6;
}

.jp-stage-block.pending {
  border-color: #e2e8f0;
  background: #f8fafc;
  opacity: 0.45;
}

@keyframes jp-pulse-border {

  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0.2);
  }

  50% {
    box-shadow: 0 0 0 6px rgba(253, 97, 1, 0);
  }
}

.jp-stage-icon {
  font-size: 15px;
  margin-bottom: 3px;
  line-height: 1;
}

.jp-stage-icon.completed {
  color: var(--success);
}

.jp-stage-icon.failed {
  color: var(--error);
}

.jp-stage-icon.running {
  color: var(--primary);
}

.jp-stage-icon.pending {
  color: #cbd5e1;
}

.jp-stage-icon.skipped {
  color: #cbd5e1;
}

.jp-stage-name {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-main);
  text-align: center;
  letter-spacing: 0.2px;
  font-family: var(--font-sans);
}

.jp-stage-duration {
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 2px;
  font-family: monospace;
}

.jp-stage-arrow {
  color: #cbd5e1;
  font-size: 12px;
  padding: 0 6px;
  flex-shrink: 0;
}

/* ---- MAIN CONTENT AREA ---- */
.jp-main {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* ---- BUILD HISTORY SIDEBAR ---- */
.jp-sidebar {
  width: 240px;
  min-width: 240px;
  background: var(--bg-card);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.jp-sidebar-header {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.jp-sidebar-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-muted);
  font-family: var(--font-sans);
}

.jp-sidebar-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 0;
}

.jp-build-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.15s;
  border-left: 2px solid transparent;
}

.jp-build-item:hover {
  background: var(--bg-page);
}

.jp-build-item.active {
  background: var(--primary-light);
  border-left-color: var(--primary);
}

.jp-build-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.jp-build-status-dot.passed {
  background: var(--success);
}

.jp-build-status-dot.failed {
  background: var(--error);
}

.jp-build-status-dot.running {
  background: var(--primary);
  animation: jp-dot-blink 1s ease-in-out infinite;
}

.jp-build-status-dot.pending {
  background: #cbd5e1;
}

.jp-build-status-dot.completed {
  background: var(--success);
}

@keyframes jp-dot-blink {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.4;
    transform: scale(0.75);
  }
}

.jp-build-item-info {
  flex: 1 1;
  overflow: hidden;
}

.jp-build-item-num {
  font-size: 12px;
  font-weight: 700;
  color: var(--primary);
  font-family: var(--font-sans);
}

.jp-build-item-name {
  font-size: 12px;
  color: var(--text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-sans);
  margin-top: 1px;
}

.jp-build-item-meta {
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 2px;
  font-family: monospace;
}

/* ---- CONSOLE TERMINAL ---- */
.jp-console {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: var(--bg-page);
  overflow: hidden;
}

.jp-console-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.jp-console-dot-group {
  display: flex;
  gap: 5px;
}

.jp-console-dot-group span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.jp-console-dot-group .dot-red {
  background: #ef4444;
}

.jp-console-dot-group .dot-yellow {
  background: #f59e0b;
}

.jp-console-dot-group .dot-green {
  background: #10b981;
}

.jp-console-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
  font-family: var(--font-sans);
}

.jp-live-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 700;
  color: var(--error);
  background: var(--error-light);
  border: 1px solid var(--error-border);
  padding: 2px 8px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  font-family: var(--font-sans);
}

.jp-live-badge-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--error);
  animation: jp-dot-blink 0.8s ease-in-out infinite;
}

.jp-hist-badge {
  font-size: 10px;
  color: var(--text-muted);
  background: var(--bg-page);
  border: 1px solid var(--border-color);
  padding: 2px 8px;
  border-radius: 20px;
  font-family: var(--font-sans);
}

.jp-console-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.jp-console-action-btn {
  background: var(--bg-page);
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: var(--font-sans);
  font-weight: 500;
}

.jp-console-action-btn:hover {
  background: var(--primary-light);
  border-color: #c4b5fd;
  color: var(--primary);
}

.jp-console-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px 16px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  margin: 12px;
  border-radius: var(--border-radius-md);
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 #ffffff;
}

.jp-console-body::-webkit-scrollbar {
  width: 5px;
}

.jp-console-body::-webkit-scrollbar-track {
  background: #f8fafc;
}

.jp-console-body::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 4px;
}

.jp-log-line {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-family: 'Consolas', 'SFMono-Regular', 'Courier New', monospace;
  font-size: 12.5px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-all;
}

.jp-log-line-num {
  color: #cbd5e1;
  min-width: 36px;
  text-align: right;
  -webkit-user-select: none;
          user-select: none;
  font-size: 11px;
  padding-top: 1px;
  flex-shrink: 0;
  border-right: 1px solid var(--border-color);
  padding-right: 8px;
  margin-right: 4px;
}

.jp-log-line-content {
  flex: 1 1;
}

/* Log color classes — adjusted for light background */
.jp-log-line.log-pass .jp-log-line-content {
  color: #047857;
}

.jp-log-line.log-fail .jp-log-line-content {
  color: #b91c1c;
}

.jp-log-line.log-warn .jp-log-line-content {
  color: #92400e;
}

.jp-log-line.log-info .jp-log-line-content {
  color: var(--primary);
}

.jp-log-line.log-stage .jp-log-line-content {
  color: #e05300;
  font-weight: 700;
}

.jp-log-line.log-heal .jp-log-line-content {
  color: #c2410c;
  font-weight: 600;
}

.jp-log-line.log-normal .jp-log-line-content {
  color: var(--text-main);
}

.jp-log-line.log-muted .jp-log-line-content {
  color: var(--text-muted);
}

/* Cursor */
@keyframes jp-cursor-blink {

  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}

.jp-cursor {
  color: var(--primary);
  animation: jp-cursor-blink 1s step-start infinite;
  font-size: 14px;
}

/* Empty state */
.jp-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
}

.jp-empty-state-icon {
  font-size: 40px;
  opacity: 0.4;
}

.jp-empty-state-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-muted);
  font-family: var(--font-sans);
}

.jp-empty-state-sub {
  font-size: 13px;
  color: var(--text-muted);
  font-family: var(--font-sans);
}

/* Result summary bar */
.jp-result-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 16px;
  background: var(--bg-card);
  border-top: 1px solid var(--border-color);
  flex-shrink: 0;
  font-family: var(--font-sans);
}

.jp-result-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
}

.jp-result-pill.pass {
  color: #047857;
  background: var(--success-light);
  border: 1px solid var(--success-border);
}

.jp-result-pill.fail {
  color: #b91c1c;
  background: var(--error-light);
  border: 1px solid var(--error-border);
}

.jp-result-pill.skip {
  color: var(--text-muted);
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

/* --- STAGE VIEW & CONSOLE TERMINAL PANEL --- */

.stage-view-layout {
  display: grid;
  grid-template-columns: 1.8fr 1.2fr;
  gap: 20px;
  margin-top: 20px;
}

@media (max-width: 1200px) {
  .stage-view-layout {
    grid-template-columns: 1fr;
  }
}

.stage-view-card {
  background: var(--bg-card);
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  padding: 24px;
  overflow-x: auto;
}

.stage-view-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px;
  font-family: var(--font-sans);
}

.stage-view-table th {
  padding: 12px;
  background: #f8fafc;
  color: var(--text-main);
  font-weight: 700;
  font-size: 13px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

/* Average timings row */
.stage-avg-row td {
  padding: 8px 12px;
  background: #f1f5f9;
  color: var(--text-muted);
  font-size: 11.5px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.stage-avg-progress-bar {
  width: 60px;
  height: 4px;
  background: #e2e8f0;
  border-radius: 2px;
  margin: 6px auto 0 auto;
  overflow: hidden;
}

.stage-avg-progress-fill {
  height: 100%;
  background: var(--primary);
  border-radius: 2px;
}

/* Run Row Metadata Cell */
.stage-run-meta-cell {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  width: 160px;
  text-align: left;
}

.stage-run-badge {
  display: inline-block;
  font-family: monospace;
  font-weight: 700;
  font-size: 12px;
  color: #ffffff;
  background: #64748b;
  padding: 2px 6px;
  border-radius: 4px;
  margin-bottom: 6px;
}

.stage-run-badge.active {
  background: var(--primary);
  animation: pulse-active-glow 1.5s infinite;
}

.stage-run-time {
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 500;
}

.stage-run-changes-btn {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  color: #475569;
  background: #e2e8f0;
  border: none;
  border-radius: 4px;
  padding: 3px 6px;
  margin-top: 6px;
  cursor: default;
}

/* Base Stage Cell */
.stage-cell {
  position: relative;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  padding: 16px 8px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  vertical-align: middle;
  min-width: 90px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.stage-cell:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

/* Cell Statuses */
.stage-cell.passed {
  background: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.stage-cell.failed {
  background-color: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}

.stage-cell.failed::after {
  content: "failed";
  position: absolute;
  bottom: 4px;
  right: 6px;
  font-size: 8.5px;
  font-weight: 800;
  text-transform: uppercase;
  color: #f87171;
  letter-spacing: 0.3px;
}

.stage-cell.skipped {
  background: #f8fafc;
  color: #94a3b8;
  border-color: #e2e8f0;
}

.stage-cell.pending {
  background: #ffffff;
  color: #cbd5e1;
  border-color: #f1f5f9;
  border-style: dashed;
}

.stage-cell.active {
  background: #eff6ff;
  color: #FD6101;
  border-color: #bfdbfe;
  animation: pulse-active-cell 1.5s infinite ease-in-out;
}

.stage-cell-loader {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid #3b82f6;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin-loader 0.8s linear infinite;
  margin-left: 6px;
  vertical-align: middle;
}

/* Animations */
@keyframes pulse-active-cell {
  0% {
    background-color: #eff6ff;
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.2);
  }

  50% {
    background-color: #dbeafe;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  }

  100% {
    background-color: #eff6ff;
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.2);
  }
}

@keyframes pulse-active-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0.4);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(253, 97, 1, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0);
  }
}

@keyframes spin-loader {
  to {
    transform: rotate(360deg);
  }
}

/* --- CONSOLE TERMINAL WINDOW --- */

.console-terminal {
  background: #020617;
  border-radius: var(--border-radius-lg);
  border: 1px solid #1e293b;
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  height: 520px;
  overflow: hidden;
  font-family: 'Courier New', Courier, monospace;
}

.console-terminal-header {
  background: #0f172a;
  border-bottom: 1px solid #1e293b;
  padding: 12px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
}

.console-terminal-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.console-terminal-search-input {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 11px;
  padding: 4px 8px;
  width: 140px;
  outline: none;
  font-family: inherit;
}

.console-terminal-search-input::placeholder {
  color: #64748b;
}

.console-terminal-btn {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #cbd5e1;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.console-terminal-btn:hover {
  background: #334155;
  color: #ffffff;
}

.console-terminal-body {
  flex-grow: 1;
  padding: 16px;
  overflow-y: auto;
  text-align: left;
  line-height: 1.6;
}

.console-terminal-body pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 11.5px;
  color: #38bdf8;
  /* Terminal bright cyan-blue */
  text-shadow: 0 0 1px rgba(56, 189, 248, 0.2);
}

.console-line-normal {
  color: #cbd5e1;
}

.console-line-highlight {
  color: #f59e0b;
  /* yellow */
  font-weight: 700;
}

.console-line-success {
  color: #10b981;
  /* green */
  font-weight: 700;
}

.console-line-error {
  color: #f87171;
  /* red */
  font-weight: 700;
}

.console-line-system {
  color: #a78bfa;
  /* purple */
  font-style: italic;
}

.console-line-filtered-out {
  display: none;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* ==========================================================================
   UNIVERSAL RESPONSIVE STYLING OVERHAUL
   ========================================================================== */

/* Hamburger toggle menu (hidden by default on desktop) */
.mobile-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--text-main);
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  margin-right: 8px;
  flex-shrink: 0;
}

.mobile-menu-toggle:hover {
  background-color: #f1f5f9;
}

.mobile-menu-toggle svg {
  width: 24px;
  height: 24px;
}

/* Base layouts responsive rules for 100% zoom and multi-resolution */
@media (max-width: 1440px) {

  /* Hide bulky header widgets so greeting and action buttons never collide */
  .header-widgets-container {
    display: none !important;
  }

  /* 2 rows of 3 compact cards so all 6 cards are visible and save 150px vertical height */
  .metrics-grid {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 12px !important;
  }

  .metric-card {
    padding: 12px 14px !important;
  }

  .metric-value {
    font-size: 20px !important;
  }

  .metric-label {
    font-size: 11.5px !important;
    margin-bottom: 3px !important;
  }

  /* Stack mid-section so creation cards have full container width */
  .mid-section-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  /* Generous 2-column or auto-fit cards where all text and buttons are 100% visible */
  .creation-cards-row {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
    gap: 12px !important;
  }

  .creation-card {
    padding: 12px 14px !important;
  }

  .creation-icon-graphic {
    height: 46px !important;
    margin-bottom: 8px !important;
  }

  .creation-title {
    font-size: 13px !important;
    font-weight: 700 !important;
    white-space: normal !important;
    overflow-wrap: break-word !important;
    margin-bottom: 4px !important;
  }

  .creation-desc {
    font-size: 11px !important;
    line-height: 1.35 !important;
    margin-bottom: 10px !important;
    min-height: auto !important;
  }

  .insights-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .bottom-section-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }
}

/* Responsive text & character resilience for 100% zoom */
h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
a,
label {
  overflow-wrap: break-word;
}

.table-container,
.table-responsive,
div[style*="overflowX: auto"],
div[style*="overflow-x: auto"] {
  max-width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td,
th {
  overflow-wrap: break-word;
}

@media (max-width: 1440px) {
  .metrics-grid {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 14px !important;
  }

  .insights-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 1100px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px !important;
  }

  .insights-grid {
    grid-template-columns: 1fr !important;
  }

  .creation-cards-row {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .gen-tabs-row {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-height: 850px) {
  .modal-card {
    padding: 18px 20px !important;
    max-height: calc(100vh - 24px) !important;
  }

  .modal-input-group {
    margin-bottom: 12px !important;
  }

  .modal-card textarea {
    height: 80px !important;
    min-height: 55px !important;
  }

  .modal-title {
    font-size: 16px !important;
    margin-bottom: 12px !important;
  }
}

@media (max-height: 700px) {
  .modal-card {
    padding: 14px 16px !important;
    max-height: calc(100vh - 16px) !important;
  }

  .modal-input-group {
    margin-bottom: 8px !important;
  }

  .modal-card textarea {
    height: 60px !important;
    min-height: 45px !important;
  }

  .modal-title {
    font-size: 15px !important;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 1024px) {

  /* Header actions and buttons must never be crushed */
  .header-actions {
    flex-shrink: 0 !important;
    white-space: nowrap !important;
  }

  .btn-new-project {
    flex-shrink: 0 !important;
    white-space: nowrap !important;
  }
}

/* Compact sidebar on screens between 769px and 1250px */
@media (max-width: 1250px) {

  .sidebar,
  .modern-sidebar {
    width: 215px !important;
    padding: 16px 10px !important;
  }
}

@media (max-width: 800px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }

  .insights-grid {
    grid-template-columns: 1fr !important;
  }

  .creation-cards-row {
    grid-template-columns: 1fr !important;
  }

  .main-content {
    padding: 14px 16px !important;
  }

  .main-header {
    padding: 0 16px !important;
    margin: 10px 16px 4px 16px !important;
    border-radius: 16px !important;
  }
}

@media (max-height: 850px) {
  .metric-card {
    padding: 10px 12px !important;
  }

  .metric-value {
    font-size: 18px !important;
  }

  .creation-icon-graphic {
    height: 40px !important;
    margin-bottom: 6px !important;
  }

  .creation-desc {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

@media (max-height: 700px) {
  .metrics-grid {
    margin-bottom: 12px !important;
  }

  .creation-icon-graphic {
    height: 36px !important;
    margin-bottom: 4px !important;
  }
}

@media (max-width: 900px) {

  /* Stack test repository grids into single column */
  .repo-grid {
    grid-template-columns: 1fr !important;
    gap: 20px;
  }

  .manual-grid {
    grid-template-columns: 1fr !important;
    gap: 20px;
  }

  .repo-sidebar,
  .manual-sidebar {
    min-height: auto !important;
  }
}

@media (max-width: 768px) {

  /* Transform Sidebar into a slide-out drawer on mobile */
  .sidebar {
    position: fixed !important;
    top: 0;
    left: -260px;
    z-index: 10001;
    height: 100vh !important;
    width: 250px !important;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.15) !important;
    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    background-color: var(--bg-sidebar) !important;
    border-right: 1px solid var(--border-color) !important;
  }

  .sidebar.mobile-open {
    left: 0 !important;
  }

  /* Overlay background layer */
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(4px);
    z-index: 10000;
  }

  /* Show hamburger button */
  .mobile-menu-toggle {
    display: flex !important;
  }

  /* Header adjustments for space saving */
  .main-header {
    padding: 10px 16px !important;
    margin: 8px 12px 4px 12px !important;
    border-radius: 16px !important;
    min-height: 70px;
    height: auto !important;
    gap: 8px;
    flex-wrap: wrap;
  }

  .header-welcome h1 {
    font-size: 18px !important;
  }

  .header-welcome p {
    font-size: 11px !important;
  }

  /* Generator tab adjustments */
  .gen-tabs-row {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px;
  }

  /* Creation Option Cards wrapping */
  .creation-cards-row {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px;
  }

  /* User profile dropdown alignment */
  .header-actions {
    gap: 10px !important;
  }

  .btn-new-project span {
    display: none;
    /* Hide 'New Project' text on mobile, keep icon */
  }

  .btn-new-project {
    padding: 10px 12px !important;
  }
}

@media (max-width: 576px) {

  /* Stats Cards alignment stacking */
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px !important;
  }

  .creation-cards-row {
    grid-template-columns: 1fr !important;
  }

  .gen-tabs-row {
    grid-template-columns: 1fr !important;
  }
}

@media (max-width: 400px) {
  .metrics-grid {
    grid-template-columns: 1fr !important;
  }
}

/* Ensure clean scrolling and no double horizontal bars on the main screen */
.main {
  width: 100%;
  overflow-x: hidden !important;
}

.main-content {
  overflow-x: hidden !important;
}

.main-content.simulator-content-active {
  padding: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  height: calc(100vh - 70px) !important;
  max-height: calc(100vh - 70px) !important;
  background-color: #f1f5f9 !important;
}

/* ==========================================================================
   SMART RESPONSIVE SIMULATOR WORKSPACE STYLES - QINTRA MODERN THEME
   ========================================================================== */

.simulator-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #f8fafc;
}

/* 1. Simulator Top Toolbar */
.simulator-toolbar {
  min-height: 56px;
  height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 10px;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  z-index: 10;
  flex-wrap: nowrap;
  overflow-x: auto;
}

/* Navigation buttons group */
.toolbar-nav-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

/* URL bar form */
.simulator-url-form {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 420px;
  min-width: 360px;
  max-width: 600px;
  flex-shrink: 0;
}

.simulator-url-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 220px;
}

.simulator-url-icon {
  position: absolute;
  left: 11px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 2;
}

.simulator-url-input {
  width: 100%;
  height: 38px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  padding: 0 32px 0 34px;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  outline: none;
  transition: all 0.2s ease;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.simulator-url-input:hover {
  border-color: #94a3b8;
}

.simulator-url-input:focus {
  border-color: #FD6101;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.15);
}

.simulator-url-clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 2;
  padding: 0;
  line-height: 1;
}

.simulator-url-clear-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
  transform: translateY(-50%) scale(1.08);
}

/* Toolbar Control Groups */
.toolbar-control-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.toolbar-label {
  font-size: 10.5px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.toolbar-select {
  height: 36px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  padding: 0 28px 0 10px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-main);
  outline: none;
  background-color: #ffffff;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  transition: all 0.2s ease;
}

.toolbar-select:hover {
  border-color: #cbd5e1;
}

.toolbar-select:focus {
  border-color: #FD6101;
  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.1);
}

.toolbar-select.zoom-select {
  width: 125px;
}

.toolbar-select.vision-select {
  width: 155px;
}

/* Viewport dimensions input */
.toolbar-num-input {
  width: 62px;
  height: 36px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  padding: 0 4px;
  font-size: 12.5px;
  font-weight: 700;
  text-align: center;
  outline: none;
  color: var(--text-main);
  background-color: #ffffff;
  transition: border-color 0.2s ease;
}

.toolbar-num-input:focus {
  border-color: #FD6101;
  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.1);
}

.toolbar-x {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 700;
}

/* Zoom controls block */
.toolbar-zoom-buttons {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  height: 36px;
  flex-shrink: 0;
}

.toolbar-zoom-buttons .toolbar-btn {
  border: none;
  border-radius: 0;
  height: 100%;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toolbar-zoom-buttons .toolbar-btn:first-child {
  border-right: 1.5px solid #e2e8f0;
}

.toolbar-zoom-buttons .toolbar-btn:last-child {
  border-left: 1.5px solid #e2e8f0;
}

.zoom-display {
  font-size: 11.5px;
  font-weight: 700;
  color: var(--text-main);
  min-width: 44px;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
}

/* Toolbar buttons */
.toolbar-btn {
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  color: var(--text-main);
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.toolbar-btn:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
  color: #0f172a;
}

.toolbar-btn.primary {
  background: #FD6101;
  color: #ffffff;
  border: none;
  box-shadow: 0 2px 6px rgba(253, 97, 1, 0.25);
}

.toolbar-btn.primary:hover {
  background: #e05300;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(224, 83, 0, 0.35);
}

.toolbar-btn.active {
  background-color: #fff7ed;
  color: #FD6101;
  border-color: #FD6101;
  font-weight: 700;
}

.toolbar-btn svg {
  color: #64748b;
  transition: color 0.2s;
}

.toolbar-btn:hover svg {
  color: var(--text-main);
}

.toolbar-btn.primary svg {
  color: #ffffff;
}

.toolbar-divider {
  width: 1px;
  height: 24px;
  background-color: #e2e8f0;
  margin: 0 2px;
  flex-shrink: 0;
}

/* 2. Breakpoint Snap Bar */
.simulator-ruler {
  min-height: 42px;
  height: 42px;
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  gap: 8px;
  overflow-x: auto;
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
  scrollbar-width: thin;
}

.breakpoint-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.breakpoint-pill:hover {
  border-color: #FD6101;
  color: #FD6101;
  background: #fff7ed;
  transform: translateY(-1px);
}

.breakpoint-pill.active {
  background: #FD6101;
  color: #ffffff;
  border-color: transparent;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(253, 97, 1, 0.3);
}

.breakpoint-pill.active:hover {
  background: #e05300;
}

.breakpoint-pill.active .bp-label {
  color: rgba(255, 255, 255, 0.9);
}

.bp-width {
  font-weight: 700;
}

.bp-label {
  font-size: 10px;
  opacity: 0.8;
}

/* 3. Simulator Canvas Area */
.simulator-canvas-container {
  flex: 1 1;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.simulator-canvas-container.theme-dots {
  background-color: #f1f5f9;
  background-image: radial-gradient(#cbd5e1 1.5px, transparent 1.5px);
  background-size: 20px 20px;
}

.simulator-canvas-container.theme-dark {
  background-color: #0b0f19;
  background-image: radial-gradient(#1e293b 1.5px, transparent 1.5px);
  background-size: 20px 20px;
}

.simulator-canvas-container.theme-clean {
  background-color: #f8fafc;
}

/* Realistic Device Frame Wrappers */
.simulator-frame-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.08);
  background-color: #ffffff;
  transition: box-shadow 0.2s ease;
}

/* Desktop browser mockup window chrome */
.simulator-frame-wrapper.frame-desktop {
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  overflow: hidden;
}

.desktop-chrome-bar {
  height: 34px;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 12px;
  -webkit-user-select: none;
          user-select: none;
}

.mac-traffic-lights {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mac-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.mac-dot.red {
  background-color: #ef4444;
}

.mac-dot.yellow {
  background-color: #f59e0b;
}

.mac-dot.green {
  background-color: #10b981;
}

.desktop-chrome-title {
  flex: 1 1;
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.desktop-chrome-badge {
  font-size: 10px;
  font-weight: 700;
  color: #475569;
  background: #e2e8f0;
  padding: 2px 7px;
  border-radius: 10px;
  font-family: monospace;
}

/* Mobile Device Shell */
.simulator-frame-wrapper.frame-mobile {
  border-radius: 42px;
  border: 11px solid #0f172a;
  box-shadow: 0 30px 70px -15px rgba(0, 0, 0, 0.4), 0 0 0 2px #334155;
  background-color: #0f172a;
  overflow: hidden;
}

.mobile-island-bar {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 96px;
  height: 22px;
  background-color: #000000;
  border-radius: 14px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-camera-dot {
  width: 8px;
  height: 8px;
  background-color: #1e293b;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 10px;
}

/* Tablet Device Shell */
.simulator-frame-wrapper.frame-tablet {
  border-radius: 28px;
  border: 13px solid #0f172a;
  box-shadow: 0 30px 70px -15px rgba(0, 0, 0, 0.35), 0 0 0 2px #334155;
  background-color: #0f172a;
  overflow: hidden;
}

.tablet-camera-dot {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 7px;
  height: 7px;
  background-color: #1e293b;
  border-radius: 50%;
  z-index: 20;
}

/* Embedded preview iframe */
.simulator-iframe {
  border: none;
  background-color: #ffffff;
  display: block;
  flex: 1 1;
}

/* Resize Handles */
.sim-resize-handle {
  position: absolute;
  background-color: transparent;
  z-index: 100;
  transition: background-color 0.2s;
}

.sim-resize-handle.right {
  top: 0;
  right: -8px;
  width: 14px;
  height: 100%;
  cursor: ew-resize;
}

.sim-resize-handle.right:hover {
  background: rgba(253, 97, 1, 0.25);
}

.sim-resize-handle.bottom {
  left: 0;
  bottom: -8px;
  width: 100%;
  height: 14px;
  cursor: ns-resize;
}

.sim-resize-handle.bottom:hover {
  background: rgba(253, 97, 1, 0.25);
}

.sim-resize-handle.corner {
  right: -9px;
  bottom: -9px;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3px solid #FD6101;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sim-resize-handle.corner::after {
  content: '';
  width: 4px;
  height: 4px;
  background-color: #FD6101;
  border-radius: 50%;
}

/* 4. Bottom Simulator Status Bar */
.simulator-status-bar {
  height: 34px;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

.status-left-group,
.status-right-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-label {
  color: #94a3b8;
  text-transform: uppercase;
  font-size: 9px;
  letter-spacing: 0.5px;
  font-weight: 700;
}

.status-value {
  color: #0f172a;
  font-weight: 700;
}

.status-badge {
  padding: 2px 6px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
  font-size: 10px;
  font-family: monospace;
}

/* Active Fullscreen overrides */
.app.fullscreen-active .sidebar {
  display: none !important;
}

.app.fullscreen-active .main-header {
  display: none !important;
}

.app.fullscreen-active .main-content {
  padding: 0 !important;
}

.rotate-btn:hover svg {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Sidebar transition and collapse styles */
.sidebar {
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1), padding 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.sidebar.collapsed {
  width: 70px !important;
  padding: 24px 8px !important;
}

.sidebar.collapsed .sidebar-logo {
  justify-content: center !important;
}

.sidebar.collapsed .sidebar-logo div {
  display: none !important;
}

.sidebar.collapsed .menu-group-label {
  display: none !important;
}

.sidebar.collapsed .sidebar-menu-btn {
  font-size: 0 !important;
  justify-content: center !important;
  padding: 10px 0 !important;
  gap: 0 !important;
}

.sidebar.collapsed .sidebar-menu-btn svg {
  margin: 0 !important;
}

.sidebar.collapsed .sidebar-submenu-btn {
  font-size: 0 !important;
  justify-content: center !important;
  padding: 8px 0 !important;
  width: 100% !important;
  margin: 0 !important;
}

/* ==========================================================================
   NEW PREMIUM BUG REPORT STYLES
   ========================================================================== */

/* Grid and layout wrappers */
.bug-grid-premium {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
  margin-top: 16px;
}

.bug-grid-compact {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

/* Premium Card Style */
.bug-card-premium {
  position: relative;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04), 0 2px 8px -1px rgba(15, 23, 42, 0.02);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  text-align: left;
}

.bug-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
}

.bug-card-premium.severity-critical::before {
  background: #ef4444;
}

.bug-card-premium.severity-high::before {
  background: #FD6101;
}

.bug-card-premium.severity-medium::before {
  background: #eab308;
}

.bug-card-premium.severity-low::before {
  background: #3b82f6;
}

.bug-card-premium:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 12px 24px -4px rgba(15, 23, 42, 0.08), 0 4px 12px -2px rgba(15, 23, 42, 0.04);
  border-color: #FD6101;
}

/* Compact Card Style */
.bug-card-compact {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
  text-align: left;
  overflow: hidden;
}

.bug-card-compact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
}

.bug-card-compact.severity-critical::before {
  background-color: #ef4444;
}

.bug-card-compact.severity-high::before {
  background-color: #f97316;
}

.bug-card-compact.severity-medium::before {
  background-color: #eab308;
}

.bug-card-compact.severity-low::before {
  background-color: #3b82f6;
}

.bug-card-compact:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  border-color: #cbd5e1;
}

/* Header/ID/Tag elements */
.bug-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bug-id-badge {
  font-family: 'Fira Code', monospace, Courier;
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.bug-id-badge:hover {
  background: #e2e8f0;
  color: var(--primary);
}

.bug-id-badge svg {
  opacity: 0.5;
  transition: opacity 0.2s;
}

.bug-id-badge:hover svg {
  opacity: 1;
}

/* Title & Breadcrumbs */
.bug-card-title {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.4;
  color: #0f172a;
  margin: 0;
  transition: color 0.2s;
}

.bug-card-breadcrumbs {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  margin-top: 4px;
}

/* Diagnostic Code Box */
.bug-diagnostic-box {
  background: #0f172a;
  color: #e2e8f0;
  font-family: 'Fira Code', monospace, Courier;
  font-size: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  overflow: auto;
  max-height: 120px;
  border-left: 4px solid #ef4444;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-all;
}

.bug-diagnostic-box.warning {
  border-left-color: #f97316;
}

/* Tab controls inside bug card */
.bug-tab-bar {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
}

.bug-tab-btn {
  background: none;
  border: none;
  font-size: 11.5px;
  font-weight: 700;
  color: #64748b;
  padding: 4px 8px;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}

.bug-tab-btn.active {
  color: var(--primary);
}

.bug-tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -7px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--primary);
}

/* Confidence gauge meter */
.confidence-meter-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.confidence-bar-bg {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.confidence-bar-fill {
  height: 100%;
  background: #10b981;
  border-radius: 3px;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.4);
}

/* Card Actions */
.bug-card-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
}

/* Healing overlay spinner inside card */
.healing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  z-index: 10;
  animation: fadeIn 0.2s ease;
}

.healing-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(253, 97, 1, 0.1);
  border-left-color: #FD6101;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.healing-text {
  font-size: 13px;
  font-weight: 700;
  color: #FD6101;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Copy alert tooltip */
.copy-tooltip {
  position: absolute;
  background: #0f172a;
  color: #ffffff;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 4px;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  animation: tooltipFade 0.2s ease;
  z-index: 20;
}

@keyframes tooltipFade {
  from {
    opacity: 0;
    transform: translate(-50%, 5px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* ==========================================================================
   IMAGE 3 AESTHETICS OVERHAUL - SOFT PASTELS & DEEP ROUNDED NESTED CARDS
   ========================================================================== */

/* Grid and layout wrappers */
.bug-grid-image1 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
  margin-top: 16px;
}

.bug-card-image1 {
  border-radius: 28px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 10px 25px -15px rgba(0, 0, 0, 0.06);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  text-align: left;
  border: 2px solid transparent;
}

/* Color matched soft pastel backgrounds */
.bug-card-image1.severity-critical {
  background: #fdf2f2;
  border-color: #fde2e2;
}

.bug-card-image1.severity-high {
  background: #fff7ed;
  border-color: #ffedd5;
}

.bug-card-image1.severity-medium {
  background: #fffbeb;
  border-color: #fef3c7;
}

.bug-card-image1.severity-low {
  background: #f0f9ff;
  border-color: #e0f2fe;
}

.bug-card-image1.status-passed,
.bug-card-image1.status-healed {
  background: #f0fdf4;
  border-color: #dcfce7;
}

.bug-card-image1:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 35px -12px rgba(0, 0, 0, 0.1);
}

.bug-card-image1::before {
  display: none !important;
}

/* Card Header */
.brand-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand-label-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #0f172a;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  font-family: inherit;
}

.brand-name-text {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

/* Soft Severity Pill Badge */
.severity-pill-image1 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid transparent;
}

.severity-pill-image1.low {
  background-color: #ffffff;
  color: #0284c7;
  border-color: #e0f2fe;
}

.severity-pill-image1.medium {
  background-color: #ffffff;
  color: #d97706;
  border-color: #fef3c7;
}

.severity-pill-image1.high {
  background-color: #ffffff;
  color: #ea580c;
  border-color: #ffedd5;
}

.severity-pill-image1.critical {
  background-color: #ffffff;
  color: #ef4444;
  border-color: #fee2e2;
}

/* Nested White Details Card */
.nested-white-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Sub-grid Metadata Blocks */
.meta-block-grid-image1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.meta-cell-image1 {
  background-color: transparent;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: left;
  border: none;
}

.meta-cell-label {
  font-size: 9.5px;
  font-weight: 700;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.meta-cell-value {
  font-size: 11.5px;
  font-weight: 700;
  color: #0f172a;
}

/* Card Body text elements */
.bug-title-image1 {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 2px 0;
  line-height: 1.4;
}

.bug-desc-image1 {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

/* Dark Accent buttons inspired by Card 1 in Image 3 */
.btn-pill-primary {
  background-color: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-pill-primary:hover {
  background-color: #1e293b;
  transform: translateY(-1px);
}

.btn-pill-secondary {
  background-color: #ffffff;
  color: #0f172a;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-pill-secondary:hover {
  background-color: #f1f5f9;
  transform: translateY(-1px);
}

/* ==========================================================================
   UNIVERSAL RABBIT BRAND CUSTOM SCROLLBAR & OVERFLOW DESIGN SYSTEM
   ========================================================================== */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
  border-radius: 9999px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(253, 97, 1, 0.45);
}

.table-responsive,
.table-container,
.modal-body,
.sidebar,
.page-wrapper,
.main-wrapper {
  overflow-y: auto !important;
  overflow-x: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,8BAA8B;EAC9B,8BAA8B;;EAE9B,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;;EAExB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;;EAEzB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;;EAEzB,oBAAoB;EACpB,qBAAqB;;EAErB,uBAAuB;EACvB,uBAAuB;;EAEvB,0CAA0C;EAC1C,mFAAmF;EACnF,qFAAqF;;EAErF,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;;EAEvB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;+EAI+E;;AAE/E;;EAEE,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,qDAAqD;EACrD,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,sGAAsG;EACtG,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;;EAEE,4KAA4K;AAC9K;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sFAAsF;EACtF,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,qHAAqH;EACrH,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,4DAA4D;AAC5D;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,sEAAsE;EACtE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;EACzD,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;EACf,0GAA0G;AAC5G;;AAEA;EACE,uCAAuC;EACvC,8EAA8E;EAC9E,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,2CAA2C;EAC3C,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,8DAA8D;EAC9D,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;;;EAGE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;+EAE+E;;AAE/E,iCAAiC;AACjC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,8DAA8D;EAC9D,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,iBAAiB;EACjB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yFAAyF;EACzF,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,iDAAiD;EACjD,0DAA0D;AAC5D;;AAEA;EACE,uCAAuC;EACvC,2FAA2F;EAC3F,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2FAA2F;AAC7F;;AAEA;EACE,mBAAmB;EACnB,6FAA6F;AAC/F;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,6CAA6C;AAC7C;EACE,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,yDAAyD;AACzD,sDAAsD;AACtD,yDAAyD;;AAEzD;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,qDAAqD;EACrD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uDAAuD;EACvD,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;iEAEiE;;AAEjE,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,4CAA4C;EAC5C,cAAc;EACd,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,uCAAuC;EACvC,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE;;IAEE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,YAAY;EACZ,sCAAsC;EACtC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;;EAEE;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oCAAoC;;AAEpC;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;+EAE+E;;AAE/E,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qEAAqE;AACrE;;EAEE,2EAA2E;EAC3E;IACE,wBAAwB;EAC1B;;EAEA,wFAAwF;EACxF;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,kEAAkE;EAClE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,oFAAoF;EACpF;IACE,sEAAsE;IACtE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA,yDAAyD;AACzD;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;;;;EAIE,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,qDAAqD;EACrD;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;AACF;;AAEA,wDAAwD;AACxD;;EAEE;;IAEE,uBAAuB;IACvB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,qCAAqC;IACrC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,mDAAmD;EACnD;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,wDAAwD;EACxD;IACE,0BAA0B;IAC1B,MAAM;IACN,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,uBAAuB;IACvB,gGAAgG;IAChG,6DAA6D;IAC7D,8CAA8C;IAC9C,sDAAsD;EACxD;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,uCAAuC;IACvC,0BAA0B;IAC1B,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,wBAAwB;EAC1B;;EAEA,wCAAwC;EACxC;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;IACvB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,8BAA8B;EAC9B;IACE,gDAAgD;IAChD,QAAQ;EACV;;EAEA,mCAAmC;EACnC;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA,oCAAoC;EACpC;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,iDAAiD;EACnD;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,mCAAmC;EACnC;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,qCAAqC;EACrC,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yDAA0R;EAC1R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sFAAsF;EACtF,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mEAAmE;EACnE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oEAAoE;EACpE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2CAA2C;AAC3C;EACE,yGAAyG;AAC3G;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;+EAE+E;;AAE/E,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yFAAyF;EACzF,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,2FAA2F;EAC3F,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;;+EAE+E;;AAE/E,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iDAAiD;EACjD,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;;EAME,2BAA2B;EAC3B,2BAA2B;AAC7B","sourcesContent":[":root {\n  /* Core Color Palette - Premium Qintra Fiery Orange Theme */\n  --bg-page: #f8fafc;\n  --bg-card: #ffffff;\n  --bg-sidebar: #ffffff;\n  /* Pure white sidebar background */\n  --sidebar-text: #64748b;\n  /* Slate/dark text */\n  --sidebar-hover: #f8fafc;\n  /* Light hover */\n  --sidebar-active-bg: #fff7ed;\n  /* Very light orange pill background */\n  --sidebar-active-text: #FD6101;\n  /* Vibrant fiery orange text */\n\n  --primary: #FD6101;\n  /* Qintra mid-body fiery orange primary */\n  --primary-hover: #e05300;\n  --primary-light: #fff7ed;\n\n  --success: #10b981;\n  --success-light: #ecfdf5;\n  --success-border: #a7f3d0;\n\n  --error: #ef4444;\n  --error-light: #fef2f2;\n  --error-border: #fecaca;\n\n  --warning: #f59e0b;\n  --warning-light: #fffbeb;\n  --warning-border: #fef3c7;\n\n  --text-main: #0f172a;\n  --text-muted: #64748b;\n\n  --border-color: #f1f5f9;\n  --border-light: #f8fafc;\n\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05);\n\n  --border-radius-lg: 16px;\n  --border-radius-md: 12px;\n  --border-radius-sm: 8px;\n\n  --font-sans: Arial, sans-serif;\n  --font-display: Arial, sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background-color: var(--bg-page);\n  color: var(--text-main);\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.35);\n  border-radius: 9999px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(253, 97, 1, 0.45);\n}\n\n/* Layout App Container */\n.app {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  background-color: var(--bg-page);\n}\n\n/* ==========================================================================\n   NEO-MINIMALIST FLOATING CARD SIDEBAR (MATCHING DESIGN MOCKUP)\n   Off-white floating shell, dark active pill buttons, elevated white active cards,\n   and vertical tree guide lines.\n   ========================================================================== */\n\n.sidebar,\n.modern-sidebar {\n  width: 250px;\n  background-color: #f0f2f5 !important;\n  color: #1e293b !important;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 24px);\n  margin: 12px 0 12px 14px;\n  border-radius: 28px !important;\n  border: 1px solid rgba(226, 232, 240, 0.9) !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;\n  flex-shrink: 0;\n  padding: 20px 14px;\n  overflow: hidden !important;\n  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s ease, margin 0.35s ease !important;\n  box-sizing: border-box;\n}\n\n/* Animated Collapsed Sidebar */\n.modern-sidebar,\n.sidebar {\n  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin 0.35s ease !important;\n}\n\n.modern-sidebar.collapsed,\n.sidebar.collapsed {\n  width: 78px !important;\n  min-width: 78px !important;\n  padding: 20px 8px !important;\n  overflow: visible !important;\n}\n\n.modern-sidebar.collapsed .sidebar-nav {\n  overflow-y: visible !important;\n  overflow-x: visible !important;\n}\n\n.modern-sidebar.collapsed .sidebar-logo {\n  justify-content: center !important;\n  padding-left: 0 !important;\n  gap: 0 !important;\n}\n\n.modern-sidebar.collapsed .menu-group {\n  position: relative;\n}\n\n.modern-sidebar.collapsed .parent-menu-item {\n  justify-content: center !important;\n  padding: 10px 0 !important;\n  width: 48px !important;\n  height: 44px !important;\n  margin: 0 auto !important;\n  border-radius: 16px !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.modern-sidebar.collapsed .parent-menu-item span {\n  display: none !important;\n}\n\n.modern-sidebar.collapsed .menu-item-left {\n  justify-content: center !important;\n  gap: 0 !important;\n}\n\n.modern-sidebar.collapsed .parent-menu-item>span.toggle-icon {\n  display: none !important;\n}\n\n.modern-sidebar.collapsed .sub-menu-tree {\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  border-left: none !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.modern-sidebar.collapsed .sub-menu-item {\n  justify-content: center !important;\n  width: 44px !important;\n  height: 40px !important;\n  padding: 0 !important;\n  border-radius: 12px !important;\n  margin: 0 auto !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.modern-sidebar.collapsed .sub-menu-item span.sub-menu-text,\n.modern-sidebar.collapsed .sub-menu-item span.dot-bullet,\n.modern-sidebar.collapsed .menu-badge {\n  display: none !important;\n}\n\n.sub-menu-item svg {\n  flex-shrink: 0;\n}\n\n.modern-sidebar.collapsed .sub-menu-item svg {\n  display: block !important;\n}\n\n.modern-sidebar.collapsed .sub-menu-item:hover {\n  background: #f1f5f9 !important;\n}\n\n.modern-sidebar.collapsed .sub-menu-item:hover svg {\n  transform: scale(1.15);\n}\n\n/* Collapsed Sidebar Floating Flyout Popover Menu */\n.sidebar-flyout-menu {\n  position: absolute;\n  left: 64px;\n  top: 0;\n  width: 220px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 14px;\n  box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.18), 0 4px 12px rgba(15, 23, 42, 0.08);\n  padding: 10px;\n  z-index: 99999;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(-8px) scale(0.95);\n  transition: opacity 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.2s;\n  pointer-events: none;\n}\n\n.modern-sidebar.collapsed .menu-group:hover .sidebar-flyout-menu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(0) scale(1);\n  pointer-events: auto;\n}\n\n.sidebar-flyout-menu .flyout-header {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #FD6101;\n  padding: 4px 8px 8px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  margin-bottom: 6px;\n}\n\n.sidebar-flyout-menu .flyout-items {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Collapsed Sidebar Hover Tooltips for Submodules & Items */\n.modern-sidebar.collapsed .sub-menu-item[data-tooltip],\n.modern-sidebar.collapsed .parent-menu-item[data-tooltip] {\n  position: relative;\n}\n\n.modern-sidebar.collapsed .sub-menu-item[data-tooltip]::after,\n.modern-sidebar.collapsed .parent-menu-item[data-tooltip]::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  left: calc(100% + 12px);\n  top: 50%;\n  transform: translateY(-50%) scale(0.92);\n  background: #0f172a;\n  color: #ffffff;\n  padding: 5px 10px;\n  border-radius: 8px;\n  font-size: 11.5px;\n  font-weight: 600;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s;\n  z-index: 100001;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.25);\n}\n\n.modern-sidebar.collapsed .sub-menu-item[data-tooltip]::before,\n.modern-sidebar.collapsed .parent-menu-item[data-tooltip]::before {\n  content: \"\";\n  position: absolute;\n  left: calc(100% + 6px);\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent #0f172a transparent transparent;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.18s ease, visibility 0.18s;\n  z-index: 100001;\n}\n\n.modern-sidebar.collapsed .sub-menu-item[data-tooltip]:hover::after,\n.modern-sidebar.collapsed .parent-menu-item[data-tooltip]:hover::after {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(-50%) scale(1);\n}\n\n.modern-sidebar.collapsed .sub-menu-item[data-tooltip]:hover::before,\n.modern-sidebar.collapsed .parent-menu-item[data-tooltip]:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.sidebar-flyout-menu .flyout-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: #334155;\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: all 0.15s ease;\n}\n\n.sidebar-flyout-menu .flyout-item:hover {\n  background: #f8fafc;\n  color: #0f172a;\n  transform: translateX(2px);\n}\n\n.sidebar-flyout-menu .flyout-item.active {\n  background: #f1f5f9;\n  color: #FD6101;\n  font-weight: 700;\n}\n\n.sidebar-toggle-btn {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n}\n\n.sidebar-toggle-btn:hover {\n  background: #FD6101;\n  color: #ffffff;\n  border-color: #FD6101;\n  box-shadow: 0 4px 14px rgba(253, 97, 1, 0.35);\n  transform: scale(1.08);\n}\n\n/* Sidebar Brand Header */\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 22px;\n  padding-left: 6px;\n}\n\n.brand-badge {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f172a;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);\n}\n\n.brand-title {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.4px;\n}\n\n/* Navigation Tree Wrapper */\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sidebar-section-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  margin: 16px 0 6px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sidebar-section-label::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e2e8f0;\n  margin-right: 8px;\n}\n\n.menu-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 6px;\n}\n\n/* Parent Level Menu Item */\n.parent-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 20px;\n  border: none;\n  background: transparent;\n  color: #334155;\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.parent-menu-item:hover {\n  background: rgba(255, 255, 255, 0.7);\n  color: #0f172a;\n}\n\n.parent-menu-item.active-black {\n  background: #FD6101 !important;\n  color: #ffffff !important;\n  font-weight: 700;\n  box-shadow: 0 6px 18px rgba(253, 97, 1, 0.3) !important;\n}\n\n.parent-menu-item.active-black:hover {\n  background: #e05300 !important;\n  box-shadow: 0 6px 20px rgba(224, 83, 0, 0.35) !important;\n}\n\n.parent-menu-item.active-black svg {\n  stroke: #ffffff !important;\n}\n\n.menu-item-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggle-icon {\n  font-size: 15px;\n  font-weight: 700;\n  opacity: 0.7;\n}\n\n/* Vertical Connector Guide Line Tree Structure */\n.sub-menu-tree {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 20px;\n  padding-left: 12px;\n  border-left: 2px solid #cbd5e1;\n  margin-top: 2px;\n  margin-bottom: 6px;\n}\n\n.sub-group-header {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 10px 0 4px 4px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.nested-sub-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-left: 4px;\n}\n\n/* Sub-menu Item Button */\n.sub-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 12px;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.sub-menu-item:hover {\n  background: rgba(255, 255, 255, 0.6);\n  color: #0f172a;\n}\n\n/* Elevated Pure White Floating Active Card */\n.sub-menu-item.active-white {\n  background: #ffffff !important;\n  color: #0f172a !important;\n  font-weight: 700 !important;\n  border-radius: 16px !important;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;\n  border: 1px solid rgba(0, 0, 0, 0.03) !important;\n}\n\n.sub-menu-item.active-white svg {\n  stroke: #0f172a !important;\n}\n\n/* Dark Pill Count Badge */\n.menu-badge {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 800;\n  padding: 2px 7px;\n  border-radius: 99px;\n}\n\n.menu-badge.dark {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n/* Main Area Container */\n.main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* Header Navbar - Curvy elevated floating card */\n.main-header {\n  height: 72px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  margin: 12px 24px 8px 16px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1000;\n  transition: all 0.25s ease;\n}\n\n.header-welcome h1 {\n  font-family: var(--font-display);\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.header-welcome p {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.btn-new-project {\n  background-color: var(--primary);\n  color: #ffffff;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: var(--border-radius-sm);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.btn-new-project:hover {\n  background-color: var(--primary-hover);\n}\n\n.header-icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.header-icon-btn:hover {\n  background-color: #f1f5f9;\n  color: var(--text-main);\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: var(--border-radius-sm);\n  transition: background-color 0.2s ease;\n}\n\n.user-profile:hover {\n  background-color: #f1f5f9;\n}\n\n.avatar-badge {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #d1fae5;\n  color: var(--primary);\n  font-weight: 700;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-details {\n  text-align: left;\n}\n\n.profile-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.profile-role {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n/* Scrollable Inner Content Area */\n.main-content {\n  flex: 1;\n  padding: 12px 24px 24px 16px;\n  overflow-y: auto;\n  background-color: var(--bg-page);\n}\n\n/* 5-Card Dashboard Metrics Grid */\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.metric-card {\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: var(--border-radius-md);\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  box-shadow: 0 16px 36px rgba(253, 97, 1, 0.15), 0 4px 12px rgba(0, 0, 0, 0.02);\n  border-color: #FD6101;\n  background: #fff7ed;\n}\n\n.metric-card:nth-child(1),\n.metric-card:nth-child(2),\n.metric-card:nth-child(3),\n.metric-card:nth-child(4),\n.metric-card:nth-child(5),\n.metric-card:nth-child(6) {\n  background: #ffffff;\n}\n\n\n.metric-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.metric-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n}\n\n.metric-value {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--text-main);\n  font-family: var(--font-display);\n}\n\n.metric-trend {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 6px;\n}\n\n.metric-trend.up {\n  color: var(--primary);\n}\n\n.metric-trend.down {\n  color: var(--error);\n}\n\n.metric-icon-wrapper {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  color: var(--text-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(2px);\n  flex-shrink: 0;\n}\n\n/* Two-column layout: Create section and Activity */\n.mid-section-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n/* Main creation/how-to card container */\n.create-panel {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n}\n\n.panel-header-title {\n  font-family: var(--font-display);\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.panel-header-subtitle {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-top: 4px;\n  margin-bottom: 20px;\n}\n\n/* The 4 large interactive widgets */\n.creation-cards-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.creation-card {\n  border: 1px solid #cbd5e1;\n  border-radius: var(--border-radius-md);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  background-color: #ffffff;\n}\n\n.creation-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.creation-card.rec:hover {\n  border-color: #ef4444;\n  background-color: #fee2e2;\n}\n\n.creation-card.url:hover {\n  border-color: #10b981;\n  background-color: #d1fae5;\n}\n\n.creation-card.img:hover {\n  border-color: #085ed1;\n  background-color: #dbeafe;\n}\n\n.creation-card.prompt:hover {\n  border-color: #f59e0b;\n  background-color: #fef3c7;\n}\n\n.creation-badge {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.creation-badge.rec {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n.creation-badge.url {\n  background-color: #d1fae5;\n  color: #059669;\n}\n\n.creation-badge.img {\n  background-color: #dbeafe;\n  color: #085ed1;\n}\n\n.creation-badge.prompt {\n  background-color: #fef3c7;\n  color: #d97706;\n}\n\n.creation-icon-graphic {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8fafc;\n  border-radius: var(--border-radius-sm);\n  margin-bottom: 12px;\n  border: 1px dashed #cbd5e1;\n}\n\n.creation-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-main);\n  margin-bottom: 6px;\n}\n\n.creation-desc {\n  font-size: 11px;\n  color: var(--text-muted);\n  line-height: 1.4;\n  margin-bottom: 16px;\n  min-height: 48px;\n}\n\n.creation-card-btn {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: var(--border-radius-sm);\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.creation-card-btn.rec {\n  border: 1px solid #f87171;\n  color: #ef4444;\n}\n\n.creation-card-btn.rec:hover {\n  background-color: #ef4444;\n  color: white;\n}\n\n.creation-card-btn.url {\n  border: 1px solid #34d399;\n  color: #059669;\n}\n\n.creation-card-btn.url:hover {\n  background-color: #059669;\n  color: white;\n}\n\n.creation-card-btn.img {\n  border: 1px solid #60a5fa;\n  color: #085ed1;\n}\n\n.creation-card-btn.img:hover {\n  background-color: #085ed1;\n  color: white;\n}\n\n.creation-card-btn.prompt {\n  border: 1px solid #fbbf24;\n  color: #d97706;\n}\n\n.creation-card-btn.prompt:hover {\n  background-color: #FFD700;\n  color: white;\n}\n\n/* Activity panel */\n.activity-panel {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-lg);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.panel-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.panel-link {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--primary);\n  background: transparent;\n  border: 1.5px solid var(--primary);\n  border-radius: 6px;\n  padding: 4px 10px;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: background 0.15s, color 0.15s;\n  line-height: 1;\n}\n\n.panel-link:hover {\n  background: var(--primary);\n  color: #ffffff;\n  text-decoration: none;\n}\n\n/* Activity Timeline items */\n.activity-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex-grow: 1;\n}\n\n.activity-item {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.activity-icon-bullet {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.activity-icon-bullet.success {\n  background-color: #ecfdf5;\n  color: #10b981;\n}\n\n.activity-icon-bullet.danger {\n  background-color: #fef2f2;\n  color: #ef4444;\n}\n\n.activity-icon-bullet.primary {\n  background-color: #ecfdf5;\n  color: #10b981;\n}\n\n.activity-icon-bullet.blue {\n  background-color: #eff6ff;\n  color: #3b82f6;\n}\n\n.activity-details {\n  flex-grow: 1;\n  text-align: left;\n}\n\n.activity-title-text {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.activity-desc-text {\n  font-size: 11.5px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.activity-time-stamp {\n  font-size: 10px;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n/* Lower Section: execution summary, test runs list, top bugs */\n.bottom-section-grid {\n  display: grid;\n  grid-template-columns: 1.2fr 1.6fr 1.6fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.summary-card {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-lg);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n}\n\n/* Donut Chart visual styles */\n.donut-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n}\n\n.donut-graphic {\n  position: relative;\n  width: 130px;\n  height: 130px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.donut-inner-white {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.donut-number {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--text-main);\n  font-family: var(--font-display);\n}\n\n.donut-label {\n  font-size: 10px;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n/* Summary Legend List */\n.legend-list {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11.5px;\n}\n\n.legend-label-block {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-muted);\n}\n\n.legend-color-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.legend-color-dot.passed {\n  background-color: var(--success);\n}\n\n.legend-color-dot.failed {\n  background-color: var(--error);\n}\n\n.legend-color-dot.skipped {\n  background-color: var(--warning);\n}\n\n.legend-color-dot.inprogress {\n  background-color: var(--primary);\n}\n\n.legend-val {\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n/* Secondary statistics below legend */\n.summary-sub-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 12px;\n  margin-top: 16px;\n  gap: 12px;\n}\n\n.sub-stat-block {\n  display: flex;\n  flex-direction: column;\n}\n\n.sub-stat-title {\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n\n.sub-stat-number {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.sub-stat-trend {\n  font-size: 10px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.sub-stat-trend.up {\n  color: var(--success);\n}\n\n.sub-stat-trend.down {\n  color: var(--error);\n}\n\n/* Table and Lists within Cards */\n.recent-runs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.run-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: var(--border-radius-sm);\n  background-color: #f8fafc;\n  border: 1px solid #f1f5f9;\n}\n\n.run-item-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.run-name-text {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.run-time-text {\n  font-size: 10.5px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.run-status-pill {\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n}\n\n.run-status-pill.passed {\n  background-color: #d1fae5;\n  color: #059669;\n}\n\n.run-status-pill.failed {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n.run-status-pill.inprogress {\n  background-color: #ecfdf5;\n  color: #10b981;\n}\n\n.run-duration {\n  font-size: 11.5px;\n  font-weight: 500;\n  color: var(--text-main);\n  font-family: monospace;\n}\n\n/* Bugs List styling */\n.bugs-list-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.bug-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: var(--border-radius-sm);\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n}\n\n.bug-info-block {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.bug-code-id {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.bug-title-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.bug-badge-pills {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.bug-pill {\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n}\n\n.bug-pill.priority-high {\n  background-color: #fef2f2;\n  color: #ef4444;\n}\n\n.bug-pill.priority-medium {\n  background-color: #fffbeb;\n  color: #d97706;\n}\n\n.bug-pill.priority-low {\n  background-color: #eff6ff;\n  color: #FD6101;\n}\n\n.bug-pill.status-new {\n  background-color: #f1f5f9;\n  color: #475569;\n}\n\n.bug-pill.status-inprogress {\n  background-color: #fffbeb;\n  color: #d97706;\n}\n\n.bug-pill.status-resolved {\n  background-color: #ecfdf5;\n  color: #10b981;\n}\n\n/* Bottom Projects Grid & Help Row */\n.bottom-projects-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n/* General clean Table Styling */\n.table-card {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-lg);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  overflow-x: auto;\n  text-align: left;\n}\n\n.projects-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 12px;\n}\n\n.projects-table th {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  text-align: left;\n}\n\n.projects-table td {\n  padding: 16px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n  color: var(--text-main);\n  text-align: left;\n}\n\n.projects-table tr:last-child td {\n  border-bottom: none;\n}\n\n.projects-table tr:hover td {\n  background-color: #fafbfc;\n}\n\n.project-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n}\n\n.project-icon {\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n}\n\n.table-status-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 12px;\n  display: inline-block;\n}\n\n.table-status-badge.healthy {\n  background-color: #d1fae5;\n  color: #059669;\n}\n\n.table-status-badge.risk {\n  background-color: #fef3c7;\n  color: #d97706;\n}\n\n.table-action-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.table-row-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.table-row-btn:hover {\n  background-color: #f1f5f9;\n  color: var(--text-main);\n}\n\n/* Help Resources Panel styling */\n.help-panel {\n  background: #002247;\n  color: white;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n  transition: all 0.25s ease;\n}\n\n.help-panel:hover {\n  background: #FD6101;\n  transform: translateY(-2px);\n}\n\n.help-panel h3 {\n  font-family: var(--font-display);\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.help-panel p {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n\n.help-links-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.help-link-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #000000;\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  text-align: left;\n}\n\n.help-link-item:hover {\n  color: #FD6101;\n}\n\n.btn-help-explore {\n  background-color: #ffffff;\n  color: var(--primary-hover);\n  border: none;\n  border-radius: var(--border-radius-sm);\n  padding: 10px;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  text-align: center;\n  transition: background-color 0.2s ease;\n}\n\n.btn-help-explore:hover {\n  background-color: #f1f5f9;\n}\n\n/* ------------------- GENERATOR PAGE REDESIGN ------------------- */\n.switch-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider.round {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: .3s;\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .3s;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.switch input:checked+.slider.round:before {\n  transform: translateX(18px);\n}\n\n.gen-url-credential-bar {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-md);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.gen-url-credential-bar label {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n  letter-spacing: 0.5px;\n}\n\n.gen-input {\n  width: 100%;\n  padding: 11px 14px;\n  border-radius: var(--border-radius-sm);\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: var(--text-main);\n  outline: none;\n  font-size: 13.5px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.gen-input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);\n}\n\n.gen-textarea {\n  width: 100%;\n  min-height: 140px;\n  padding: 14px;\n  border-radius: var(--border-radius-md);\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: var(--text-main);\n  outline: none;\n  font-size: 14px;\n  line-height: 1.6;\n  resize: vertical;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-sm);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.gen-textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);\n}\n\n/* Interactive tab selections in Generator Page */\n.gen-tabs-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.gen-tab {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-md);\n  padding: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-shadow: var(--shadow-sm);\n}\n\n.gen-tab.active {\n  border-color: var(--primary);\n  background-color: rgba(16, 185, 129, 0.03);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.gen-tab.record.active {\n  border-color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.03);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.gen-tab.record.active svg {\n  color: #ef4444;\n}\n\n.gen-tab.record.active .gen-tab-label {\n  color: #ef4444;\n}\n\n.gen-tab.url.active {\n  border-color: var(--primary);\n  background-color: rgba(16, 185, 129, 0.03);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.gen-tab.url.active svg {\n  color: var(--primary);\n}\n\n.gen-tab.url.active .gen-tab-label {\n  color: var(--primary);\n}\n\n.gen-tab.screenshots.active {\n  border-color: #FD6101;\n  background-color: rgba(37, 99, 235, 0.03);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.gen-tab.screenshots.active svg {\n  color: #FD6101;\n}\n\n.gen-tab.screenshots.active .gen-tab-label {\n  color: #FD6101;\n}\n\n.gen-tab.prompt.active {\n  border-color: #FFD700;\n  background-color: rgba(234, 179, 8, 0.03);\n  box-shadow: 0 0 0 3px rgba(234, 179, 8, 0.1);\n}\n\n.gen-tab.prompt.active svg {\n  color: #FFD700;\n}\n\n.gen-tab.prompt.active .gen-tab-label {\n  color: #FFD700;\n}\n\n.gen-tab svg {\n  width: 22px;\n  height: 22px;\n  color: var(--text-muted);\n}\n\n.gen-tab.active svg {\n  color: var(--primary);\n}\n\n.gen-tab-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.gen-tab.active .gen-tab-label {\n  color: var(--primary);\n}\n\n/* Code Editor Card visual wrappers */\n.code-card {\n  background-color: #0f172a;\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--primary);\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n  text-align: left;\n}\n\n.code-card-header {\n  background-color: #1e293b;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #334155;\n}\n\n.code-card-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #f8fafc;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.code-card pre {\n  margin: 0;\n  padding: 20px;\n  background-color: #0b0f19;\n  color: #ffffff;\n  /* White syntax code highlight! */\n  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;\n  font-size: 12.5px;\n  line-height: 1.7;\n  overflow-x: auto;\n  min-height: 200px;\n  max-height: 400px;\n  text-align: left;\n}\n\n/* Clean UI checklist table */\n.checklist-card {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n}\n\n/* Interactive Action Buttons Row */\n.action-bar-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: white;\n  border: none;\n  padding: 11px 22px;\n  font-weight: 600;\n  font-size: 13.5px;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.btn-primary:hover {\n  background-color: var(--primary-hover);\n}\n\n.btn-secondary {\n  background-color: #ffffff;\n  color: var(--text-main);\n  border: 1px solid #e2e8f0;\n  padding: 11px 22px;\n  font-weight: 600;\n  font-size: 13.5px;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.btn-danger {\n  background-color: #fee2e2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n  padding: 11px 22px;\n  font-weight: 600;\n  font-size: 13.5px;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-danger:hover {\n  background-color: #ef4444;\n  color: white;\n  border-color: #ef4444;\n}\n\n.gen-select {\n  padding: 11px 14px;\n  border-radius: var(--border-radius-sm);\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  color: var(--text-main);\n  font-size: 13.5px;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.gen-select:focus {\n  border-color: var(--primary);\n}\n\n/* ------------------- TEST CASES PAGE REDESIGN ------------------- */\n.repo-grid {\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  gap: 24px;\n}\n\n.repo-sidebar {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-lg);\n  padding: 20px;\n  height: fit-content;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n}\n\n.repo-sidebar-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 16px;\n}\n\n.project-list-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: var(--border-radius-sm);\n  border: 1px solid #f1f5f9;\n  background-color: #ffffff;\n  cursor: pointer;\n  margin-bottom: 8px;\n  transition: all 0.2s ease;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-main);\n  text-align: left;\n}\n\n.project-list-btn:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.project-list-btn.active {\n  background-color: var(--primary-light);\n  border-color: var(--primary);\n  color: var(--primary-hover);\n  font-weight: 600;\n}\n\n.project-list-btn-badge {\n  font-size: 10.5px;\n  font-weight: 600;\n  background-color: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 10px;\n  color: var(--text-muted);\n}\n\n.project-list-btn.active .project-list-btn-badge {\n  background-color: #ffffff;\n  color: var(--primary-hover);\n}\n\n.repo-content-pane {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.repo-tc-card {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-md);\n  padding: 18px;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: border-color 0.2s ease;\n}\n\n.repo-tc-card:hover {\n  border-color: var(--primary-light);\n}\n\n.repo-tc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.repo-tc-title-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--text-main);\n  cursor: pointer;\n  text-align: left;\n}\n\n.repo-tc-checkbox {\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n  accent-color: var(--primary);\n}\n\n.repo-tc-action-bar {\n  display: flex;\n  gap: 8px;\n}\n\n.repo-tc-action-btn {\n  padding: 6px 12px;\n  font-size: 11.5px;\n  font-weight: 600;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n.repo-tc-action-btn.view {\n  background-color: #f1f5f9;\n  color: var(--text-main);\n  border: 1px solid #cbd5e1;\n}\n\n.repo-tc-action-btn.view:hover {\n  background-color: #e2e8f0;\n}\n\n.repo-tc-action-btn.run {\n  background-color: var(--success);\n  color: white;\n}\n\n.repo-tc-action-btn.run:hover {\n  background-color: #059669;\n}\n\n.repo-tc-action-btn.delete {\n  background-color: #fee2e2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n}\n\n.repo-tc-action-btn.delete:hover {\n  background-color: #ef4444;\n  color: white;\n  border-color: #ef4444;\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.65);\n  backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  z-index: 10005;\n  padding: clamp(12px, 3vh, 28px) clamp(8px, 2.5vw, 20px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n}\n\n.modal-card {\n  width: 100%;\n  max-width: 520px;\n  max-height: calc(100vh - 44px);\n  background-color: #ffffff;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid #f1f5f9;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  margin: auto 0;\n  position: relative;\n}\n\n/* Modal action footer sticky pinned to bottom so Save/Cancel are always visible */\n.modal-card>div:last-child,\n.modal-actions,\n.modal-footer {\n  position: sticky;\n  bottom: -24px;\n  background: #ffffff;\n  padding-top: 14px;\n  padding-bottom: 4px;\n  margin-top: auto;\n  border-top: 1px solid #f1f5f9;\n  z-index: 10;\n  flex-shrink: 0;\n}\n\n.modal-title {\n  font-family: var(--font-display);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-main);\n  margin-bottom: 16px;\n}\n\n.modal-input-group {\n  margin-bottom: 20px;\n}\n\n.modal-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n}\n\n/* ------------------- ANALYTICS / MOCK PAGES STYLES ------------------- */\n.insights-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.insight-metric-card {\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-md);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n}\n\n.insight-graph-bar {\n  height: 8px;\n  background-color: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: 12px;\n}\n\n.insight-graph-fill {\n  height: 100%;\n  background-color: var(--primary);\n  border-radius: 4px;\n}\n\n/* ==========================================================================\n   PREMIUM INTERACTIVE UPGRADE STYLES (Rabbit)\n   ========================================================================== */\n\n/* 1. Live Step Runner Timeline */\n.live-runner-card {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n  margin-top: 16px;\n}\n\n.live-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  position: relative;\n  padding-left: 32px;\n  margin-top: 20px;\n}\n\n.live-timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 11px;\n  top: 8px;\n  bottom: 8px;\n  width: 2px;\n  background-color: #f1f5f9;\n}\n\n.live-timeline-step {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.live-timeline-bullet {\n  position: absolute;\n  left: -32px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 2px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.live-timeline-step.completed .live-timeline-bullet {\n  background-color: var(--success);\n  border-color: var(--success);\n  color: #ffffff;\n  box-shadow: 0 0 8px rgba(16, 185, 129, 0.3);\n}\n\n.live-timeline-step.active .live-timeline-bullet {\n  background-color: #ffffff;\n  border-color: var(--primary);\n  color: var(--primary);\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15);\n  animation: pulse-border 1.5s infinite alternate;\n}\n\n.live-timeline-step.failed .live-timeline-bullet {\n  background-color: var(--error);\n  border-color: var(--error);\n  color: #ffffff;\n  box-shadow: 0 0 8px rgba(239, 68, 68, 0.3);\n}\n\n.live-timeline-step.skipped .live-timeline-bullet {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #94a3b8;\n}\n\n.live-timeline-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.live-timeline-label {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #64748b;\n  transition: color 0.3s ease;\n}\n\n.live-timeline-step.active .live-timeline-label {\n  color: var(--text-main);\n  font-weight: 700;\n}\n\n.live-timeline-step.completed .live-timeline-label {\n  color: var(--text-main);\n}\n\n.live-timeline-step.failed .live-timeline-label {\n  color: var(--error);\n  font-weight: 700;\n}\n\n@keyframes pulse-border {\n  from {\n    box-shadow: 0 0 0 0px rgba(16, 185, 129, 0.3);\n  }\n\n  to {\n    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.15);\n  }\n}\n\n/* 2. Visual Regression Split Screen Slider */\n.visual-slider-card {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n  margin-top: 16px;\n}\n\n.slider-wrapper {\n  position: relative;\n  width: 100%;\n  height: 300px;\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n  user-select: none;\n  cursor: ew-resize;\n  border: 1px solid #cbd5e1;\n  box-shadow: var(--shadow-md);\n}\n\n.slider-panel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-panel-content {\n  width: 100%;\n  height: 100%;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.slider-bar-divider {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  z-index: 10;\n  pointer-events: none;\n}\n\n.slider-drag-handle {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: var(--primary);\n  border: 3px solid #ffffff;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n  cursor: ew-resize;\n  z-index: 11;\n  pointer-events: none;\n  font-size: 14px;\n}\n\n/* Mock Dashboard Previews inside Slider */\n.mock-app-header {\n  height: 40px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 15px;\n  border-radius: 6px 6px 0 0;\n}\n\n.mock-app-body {\n  flex-grow: 1;\n  background-color: #ffffff;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mock-app-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 12px;\n  text-align: center;\n  border: none;\n  cursor: pointer;\n  align-self: flex-start;\n  transition: all 0.2s;\n}\n\n.mock-app-button.expected {\n  background-color: var(--success);\n  color: white;\n}\n\n.mock-app-button.actual {\n  background-color: var(--error);\n  color: white;\n  position: relative;\n  animation: visual-mismatch-shake 0.8s infinite alternate;\n}\n\n@keyframes visual-mismatch-shake {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(8px);\n  }\n}\n\n.visual-regression-label-badge {\n  position: absolute;\n  top: 10px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #ffffff;\n  z-index: 5;\n  box-shadow: var(--shadow-sm);\n}\n\n.visual-regression-label-badge.expected {\n  left: 10px;\n  background-color: var(--success);\n}\n\n.visual-regression-label-badge.actual {\n  right: 10px;\n  background-color: var(--error);\n}\n\n/* 3. Locator Health Heatmap */\n.health-heatmap-card {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-sm);\n  text-align: left;\n  margin-top: 24px;\n}\n\n.heatmap-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.heatmap-cell {\n  border-radius: var(--border-radius-sm);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 90px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid transparent;\n  position: relative;\n}\n\n.heatmap-cell:hover {\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: var(--shadow-md);\n  z-index: 10;\n}\n\n.heatmap-cell.healthy {\n  background-color: rgba(16, 185, 129, 0.08);\n  border-color: rgba(16, 185, 129, 0.15);\n  color: #065f46;\n}\n\n.heatmap-cell.brittle {\n  background-color: rgba(245, 158, 11, 0.08);\n  border-color: rgba(245, 158, 11, 0.15);\n  color: #92400e;\n}\n\n.heatmap-cell.flaky {\n  background-color: rgba(239, 68, 68, 0.08);\n  border-color: rgba(239, 68, 68, 0.15);\n  color: #991b1b;\n}\n\n.heatmap-cell-title {\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 700;\n  word-break: break-all;\n}\n\n.heatmap-cell-status {\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.heatmap-popover {\n  background: #0f172a;\n  color: #f8fafc;\n  border-radius: var(--border-radius-md);\n  padding: 16px;\n  margin-top: 16px;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid #334155;\n  animation: slide-up 0.2s ease-out;\n}\n\n@keyframes slide-up {\n  from {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* 4. Low-Code Scenario Builder */\n.builder-canvas {\n  background-color: #f8fafc;\n  border: 2px dashed #cbd5e1;\n  border-radius: var(--border-radius-md);\n  padding: 20px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.builder-step-row {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--border-radius-sm);\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  box-shadow: var(--shadow-sm);\n  animation: step-fade-in 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes step-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.builder-step-num {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--primary-light);\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 11px;\n}\n\n.builder-step-badge {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 4px;\n  background-color: #cbd5e1;\n  color: #334155;\n}\n\n.builder-step-badge.navigate {\n  background-color: #eff6ff;\n  color: #FD6101;\n}\n\n.builder-step-badge.type {\n  background-color: #f0fdf4;\n  color: #166534;\n}\n\n.builder-step-badge.click {\n  background-color: #fef2f2;\n  color: #991b1b;\n}\n\n.builder-step-badge.assert {\n  background-color: #faf5ff;\n  color: #6b21a8;\n}\n\n/* Dynamic Bouncing Dots Loader */\n.loader {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.loader-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #10b981;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.loader-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.loader-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1.0);\n  }\n}\n\n/* 1. Pulse Loader for Button Text */\n.pulse-loader {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background-color: currentColor;\n  border-radius: 50%;\n  animation: pulse 1.2s infinite ease-in-out;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.6);\n    opacity: 0.6;\n  }\n\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(0.6);\n    opacity: 0.6;\n  }\n}\n\n/* 2. Premium Ring Loader for Small Spinners */\n.ring-loader {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--primary-light);\n  border-top: 2px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 0.8s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ring-loader.white {\n  border-color: rgba(255, 255, 255, 0.2);\n  border-top-color: #ffffff;\n}\n\n/* 3. Line Scale Loader for Datasets */\n.line-scale-loader {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-right: 8px;\n}\n\n.line-scale-loader div {\n  width: 3px;\n  height: 15px;\n  background-color: var(--primary);\n  animation: line-scale 1.2s infinite ease-in-out;\n}\n\n.line-scale-loader div:nth-child(1) {\n  animation-delay: -1.2s;\n}\n\n.line-scale-loader div:nth-child(2) {\n  animation-delay: -1.1s;\n}\n\n.line-scale-loader div:nth-child(3) {\n  animation-delay: -1s;\n}\n\n.line-scale-loader div:nth-child(4) {\n  animation-delay: -0.9s;\n}\n\n.line-scale-loader div:nth-child(5) {\n  animation-delay: -0.8s;\n}\n\n@keyframes line-scale {\n\n  0%,\n  40%,\n  100% {\n    transform: scaleY(0.4);\n  }\n\n  20% {\n    transform: scaleY(1);\n  }\n}\n\n/* Sidebar Tree Lines layout */\n.sidebar-menu-group-list {\n  position: relative;\n  padding-left: 14px;\n  margin-left: 6px;\n  border-left: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 6px;\n  margin-bottom: 12px;\n}\n\n.sidebar-menu-group-list .sidebar-menu-btn {\n  position: relative;\n  margin-bottom: 2px;\n  padding-left: 12px;\n}\n\n.sidebar-menu-group-list .sidebar-menu-btn::before {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 50%;\n  width: 10px;\n  height: 1px;\n  background-color: #e2e8f0;\n}\n\n/* Header widgets */\n.header-widgets-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  justify-content: center;\n  padding: 0 16px;\n  min-width: 0;\n}\n\n.header-widget-pill {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: var(--border-radius-md);\n  padding: 8px 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap !important;\n  word-break: keep-all !important;\n  overflow-wrap: normal !important;\n  flex-shrink: 0;\n}\n\n.header-widget-pill:hover {\n  background-color: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.header-widget-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n}\n\n.cron-sync-icon svg {\n  animation: none;\n}\n\n.cron-sync-icon:hover svg {\n  animation: spin-sync 2s linear infinite;\n}\n\n@keyframes spin-sync {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.live-clock-pill:hover .header-widget-icon svg {\n  animation: clock-wiggle 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes clock-wiggle {\n  from {\n    transform: rotate(-8deg);\n  }\n\n  to {\n    transform: rotate(8deg);\n  }\n}\n\n.header-widget-text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.header-widget-title {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-muted);\n  line-height: 1.2;\n}\n\n.header-widget-desc {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-main);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  line-height: 1.3;\n}\n\n.status-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.status-dot.green {\n  background-color: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n}\n\n.header-widget-chevron {\n  display: flex;\n  align-items: center;\n  color: var(--text-muted);\n  margin-left: 4px;\n}\n\n.header-action-circle-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 1px solid #f1f5f9;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.header-action-circle-btn:hover {\n  background-color: #f8fafc;\n  color: var(--text-main);\n  border-color: #e2e8f0;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.avatar-badge {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  /* square-like rounded corner from mockup */\n  background-color: #fff7ed;\n  color: var(--primary);\n  font-weight: 700;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Segmented circular gauge styling */\n.test-summary-layout {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 16px;\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.gauge-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gauge-legend-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n}\n\n.gauge-legend-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.gauge-legend-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.gauge-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.gauge-legend-dot.passed {\n  background-color: var(--success);\n}\n\n.gauge-legend-dot.failed {\n  background-color: var(--error);\n}\n\n.gauge-legend-val {\n  font-size: 12px;\n  color: var(--text-muted);\n  padding-left: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.trend-arrow-up {\n  color: var(--success);\n  font-weight: 700;\n}\n\n.trend-arrow-down {\n  color: var(--error);\n  font-weight: 700;\n}\n\n/* ==========================================================================\n   MANUAL TEST CASES & GOOGLE SHEETS SYNC STYLES\n   ========================================================================== */\n\n.manual-grid {\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 24px;\n  margin-top: 16px;\n  align-items: start;\n}\n\n.manual-sidebar {\n  background: var(--bg-card);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: var(--border-radius-md);\n  padding: 16px;\n  min-height: 400px;\n}\n\n.manual-sidebar-title {\n  font-family: var(--font-display);\n  font-size: 15px;\n  font-weight: 700;\n  margin: 0 0 16px 0;\n  color: var(--text-main);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.manual-project-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-radius: var(--border-radius-sm);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text-main);\n  width: 100%;\n  margin-bottom: 6px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.manual-project-btn:hover {\n  background: rgba(124, 92, 246, 0.05);\n  transform: translateX(2px);\n}\n\n.manual-project-btn.active {\n  background: var(--primary);\n  color: #ffffff !important;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(124, 92, 246, 0.2);\n}\n\n.manual-project-btn.active .project-badge {\n  background: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n}\n\n.project-badge {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 20px;\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--text-muted);\n  font-weight: 700;\n}\n\n.manual-main-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.manual-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.priority-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.priority-badge.high {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.priority-badge.medium {\n  background-color: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.priority-badge.low {\n  background-color: rgba(37, 99, 235, 0.1);\n  color: #FD6101;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.status-badge.passed {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.status-badge.failed {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.status-badge.blocked {\n  background-color: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n.status-badge.untested {\n  background-color: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n/* execution wizard styles */\n.exec-wizard-container {\n  background: var(--bg-card);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: var(--border-radius-md);\n  padding: 24px;\n  margin-top: 16px;\n  box-shadow: var(--shadow-lg);\n  animation: slideUp 0.3s ease;\n}\n\n.exec-wizard-header {\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 16px;\n  margin-bottom: 20px;\n}\n\n.exec-step-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.exec-step-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: var(--border-radius-sm);\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.exec-step-row.completed {\n  background: rgba(16, 185, 129, 0.04);\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.exec-step-row.failed {\n  background: rgba(239, 68, 68, 0.04);\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.exec-step-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.step-number-pill {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.exec-step-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.step-action-btn {\n  padding: 6px 12px;\n  border-radius: var(--border-radius-sm);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all 0.15s ease;\n}\n\n.step-action-btn.pass {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.step-action-btn.pass:hover,\n.step-action-btn.pass.active {\n  background: #10b981;\n  color: white;\n}\n\n.step-action-btn.fail {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.step-action-btn.fail:hover,\n.step-action-btn.fail.active {\n  background: #ef4444;\n  color: white;\n}\n\n/* Google Sync Card styles */\n.sync-card {\n  background: #fff7ed;\n  border: 1px dashed #FD6101;\n  border-radius: var(--border-radius-md);\n  padding: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n  transition: all 0.2s ease;\n}\n\n.sync-card:hover {\n  background: #ffedd5;\n  border-color: #e05300;\n}\n\n.sync-status-alert {\n  padding: 12px 16px;\n  border-radius: var(--border-radius-sm);\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 500;\n}\n\n.sync-status-alert.configured {\n  background: rgba(16, 185, 129, 0.08);\n  color: #10b981;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.sync-status-alert.missing {\n  background: rgba(245, 158, 11, 0.08);\n  color: #f59e0b;\n  border: 1px solid rgba(245, 158, 11, 0.2);\n}\n\n.steps-list-preview {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 13px;\n  color: var(--text-main);\n  line-height: 1.5;\n}\n\n.steps-list-preview li {\n  margin-bottom: 4px;\n}\n\n/* Sidebar Submenu Dropdown */\n.sidebar-dropdown-parent {\n  position: relative;\n  width: 100%;\n}\n\n.sidebar-dropdown-content {\n  display: none;\n  flex-direction: column;\n  padding-left: 20px;\n  margin-top: 4px;\n  margin-bottom: 8px;\n  border-left: 1px solid rgba(226, 232, 240, 0.4);\n  margin-left: 14px;\n  gap: 4px;\n  animation: fadeIn 0.2s ease;\n}\n\n/* Hover or active behavior to show dropdown sub-items */\n.sidebar-dropdown-parent:hover .sidebar-dropdown-content {\n  display: flex;\n}\n\n.sidebar-dropdown-parent.active-parent .sidebar-dropdown-content {\n  display: flex;\n}\n\n/* Styles for submenu buttons */\n.sidebar-submenu-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  color: var(--text-muted);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s ease;\n  width: calc(100% - 14px);\n}\n\n.sidebar-submenu-btn:hover {\n  background: rgba(124, 92, 246, 0.05);\n  color: var(--text-main);\n}\n\n.sidebar-submenu-btn.active {\n  background: rgba(124, 92, 246, 0.1);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.sidebar-submenu-btn .bullet {\n  font-size: 14px;\n  opacity: 0.5;\n}\n\n.sidebar-submenu-btn.active .bullet {\n  color: var(--primary);\n  opacity: 1;\n}\n\n.dropdown-arrow {\n  margin-left: auto;\n  font-size: 10px;\n  opacity: 0.6;\n  transition: transform 0.2s ease;\n}\n\n.sidebar-dropdown-parent:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n/* Test case clickable links styling */\n.tc-id-link {\n  color: var(--primary);\n  cursor: pointer;\n  transition: color 0.2s ease, text-decoration 0.2s ease;\n}\n\n.tc-id-link:hover {\n  color: var(--primary-hover);\n  text-decoration: underline;\n}\n\n.tc-title-link {\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.tc-title-link:hover {\n  color: var(--primary);\n}\n\n/* Floating Run Selected button style */\n.floating-run-selected {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #FD6101;\n  color: #ffffff;\n  padding: 14px 28px;\n  border-radius: 50px;\n  box-shadow: 0 10px 25px -5px rgba(253, 97, 1, 0.4), 0 8px 10px -6px rgba(253, 97, 1, 0.3);\n  cursor: pointer;\n  font-family: var(--font-display, sans-serif);\n  font-weight: 700;\n  font-size: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  animation: float-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.floating-run-selected:hover {\n  transform: translateY(-4px) scale(1.03);\n  box-shadow: 0 20px 30px -10px rgba(224, 83, 0, 0.5), 0 10px 15px -5px rgba(224, 83, 0, 0.4);\n  background: #e05300;\n}\n\n.floating-run-selected:active {\n  transform: translateY(-1px) scale(0.98);\n  box-shadow: 0 5px 15px -3px rgba(253, 97, 1, 0.4);\n  background: #c2410c;\n}\n\n.floating-run-selected.running {\n  background: #dc2626;\n  box-shadow: 0 10px 25px -5px rgba(220, 38, 38, 0.4), 0 8px 10px -6px rgba(220, 38, 38, 0.4);\n}\n\n.floating-run-selected.running:hover {\n  background: #b91c1c;\n  box-shadow: 0 20px 30px -10px rgba(220, 38, 38, 0.6), 0 10px 15px -5px rgba(220, 38, 38, 0.6);\n}\n\n@keyframes float-in {\n  0% {\n    transform: translateY(100px) scale(0.8);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* Global Execution Progress Banner styling */\n.global-execution-banner {\n  border-left: 5px solid var(--primary, #10b981) !important;\n}\n\n.global-execution-banner.failed {\n  border-left: 5px solid #ef4444 !important;\n}\n\n.global-execution-banner.completed {\n  border-left: 5px solid #10b981 !important;\n}\n\n@keyframes slide-up-banner {\n  0% {\n    transform: translateY(150px) scale(0.9);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-toast {\n  0% {\n    transform: translateX(120%) scale(0.9);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* ==================================================== */\n/* REDESIGNED CROSS-BROWSER VALIDATION MATRIX STYLES */\n/* ==================================================== */\n\n.matrix-section-container {\n  margin: 24px 0;\n  text-align: left;\n  width: 100%;\n}\n\n.matrix-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-sm);\n}\n\n.matrix-summary-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  gap: 16px;\n  flex: 1;\n}\n\n.matrix-stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.matrix-stat-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.matrix-stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.matrix-stat-value.passed {\n  color: var(--success);\n}\n\n.matrix-stat-value.failed {\n  color: var(--error);\n}\n\n.matrix-stat-value.running {\n  color: var(--warning);\n}\n\n.matrix-stat-value.queued {\n  color: #3b82f6;\n}\n\n.matrix-overall-success {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-left: 24px;\n  border-left: 1px solid var(--border-color);\n}\n\n.matrix-progress-ring-container {\n  position: relative;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.matrix-progress-ring-text {\n  position: absolute;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.matrix-filter-section {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  padding: 16px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  box-shadow: var(--shadow-sm);\n}\n\n.matrix-search-input-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 250px;\n}\n\n.matrix-search-input {\n  width: 100%;\n  padding: 10px 16px 10px 38px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  background-color: var(--bg-page);\n  font-size: 13px;\n  color: var(--text-main);\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.matrix-search-input:focus {\n  border-color: var(--primary);\n}\n\n.matrix-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.matrix-filters-group {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.matrix-select-filter {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  background-color: var(--bg-card);\n  color: var(--text-main);\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n}\n\n.matrix-select-filter:focus {\n  border-color: var(--primary);\n}\n\n.matrix-card-grid {\n  display: grid;\n  gap: 20px;\n  margin-bottom: 24px;\n  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n}\n\n.matrix-project-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.matrix-project-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.matrix-card-header {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color);\n  background: #fafafa;\n}\n\n.matrix-card-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.matrix-project-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-main);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.matrix-card-header-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-bottom: 12px;\n}\n\n.matrix-header-stat-box {\n  background: var(--bg-page);\n  padding: 4px 6px;\n  border-radius: var(--border-radius-sm);\n  text-align: center;\n  font-weight: 600;\n}\n\n.matrix-badge-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px dashed var(--border-color);\n  padding-top: 10px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.matrix-badge-browser-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.matrix-tc-list-container {\n  height: 350px;\n  overflow-y: auto;\n  position: relative;\n}\n\n/* Scrollbar styles */\n.matrix-tc-list-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.matrix-tc-list-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.matrix-tc-list-container::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.matrix-tc-list-container::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.matrix-tc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.matrix-tc-table th {\n  position: sticky;\n  top: 0;\n  background: var(--bg-card);\n  color: var(--text-muted);\n  font-weight: 600;\n  text-align: left;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-color);\n  z-index: 2;\n}\n\n.matrix-tc-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.matrix-tc-row {\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.matrix-tc-row:hover {\n  background-color: var(--bg-page);\n}\n\n.matrix-tc-name-cell {\n  font-weight: 600;\n  color: var(--text-main);\n  max-width: 130px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Status Chips/Pills */\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n\n.status-pill.pass {\n  background-color: var(--success-light);\n  color: var(--success);\n  border: 1px solid var(--success-border);\n}\n\n.status-pill.fail {\n  background-color: var(--error-light);\n  color: var(--error);\n  border: 1px solid var(--error-border);\n}\n\n.status-pill.running {\n  background-color: var(--warning-light);\n  color: var(--warning);\n  border: 1px solid var(--warning-border);\n}\n\n.status-pill.queued {\n  background-color: #eff6ff;\n  color: #3b82f6;\n  border: 1px solid #bfdbfe;\n}\n\n.status-pill.not-run {\n  background-color: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.matrix-card-footer {\n  padding: 10px 16px;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background-color: var(--bg-card);\n  font-weight: 600;\n  color: var(--primary);\n  font-size: 12px;\n  transition: background-color 0.2s;\n}\n\n.matrix-card-footer:hover {\n  background-color: var(--primary-light);\n}\n\n/* Detail Modal Styles */\n.matrix-detail-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n  animation: fade-in 0.2s ease-out;\n}\n\n.matrix-detail-modal {\n  background: var(--bg-card);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 95%;\n  max-width: 1100px;\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: scale-up 0.2s ease-out;\n}\n\n.matrix-detail-header {\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.matrix-detail-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-main);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.matrix-detail-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.matrix-detail-sidebar {\n  width: 280px;\n  border-right: 1px solid var(--border-color);\n  overflow-y: auto;\n  padding: 16px;\n  background-color: #fafafa;\n}\n\n.matrix-detail-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: var(--bg-page);\n}\n\n.matrix-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.matrix-detail-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  padding: 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.matrix-detail-label {\n  font-size: 11px;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.matrix-detail-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.matrix-log-viewer {\n  background-color: #0f172a;\n  color: #f8fafc;\n  font-family: Consolas, Monaco, 'Courier New', monospace;\n  font-size: 12px;\n  padding: 16px;\n  border-radius: var(--border-radius-md);\n  height: 250px;\n  overflow-y: auto;\n  text-align: left;\n  white-space: pre-wrap;\n}\n\n.matrix-history-item {\n  padding: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  background: var(--bg-card);\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.matrix-history-item:hover {\n  border-color: var(--primary);\n  background-color: var(--primary-light);\n}\n\n.matrix-history-item.active {\n  border-color: var(--primary);\n  background-color: var(--primary-light);\n  box-shadow: var(--shadow-sm);\n}\n\n.matrix-close-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.matrix-close-btn:hover {\n  color: var(--text-main);\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scale-up {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* ============================================================\n   PIPELINE EXECUTION — Product Theme (Violet/Purple)\n   ============================================================ */\n\n/* Root container */\n.jp-root {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 64px);\n  background: var(--bg-page);\n  color: var(--text-main);\n  font-family: var(--font-sans);\n  overflow: hidden;\n}\n\n/* ---- TOP HEADER BAR ---- */\n.jp-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 56px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n  gap: 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.jp-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.jp-header-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.jp-build-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.jp-build-number {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--primary);\n  letter-spacing: -0.5px;\n}\n\n.jp-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.jp-status-badge.running {\n  background: var(--primary-light);\n  color: var(--primary);\n  border: 1px solid #c4b5fd;\n}\n\n.jp-status-badge.passed {\n  background: var(--success-light);\n  color: #047857;\n  border: 1px solid var(--success-border);\n}\n\n.jp-status-badge.failed {\n  background: var(--error-light);\n  color: #b91c1c;\n  border: 1px solid var(--error-border);\n}\n\n.jp-status-badge.pending {\n  background: #f1f5f9;\n  color: var(--text-muted);\n  border: 1px solid #e2e8f0;\n}\n\n.jp-status-badge.completed {\n  background: var(--success-light);\n  color: #047857;\n  border: 1px solid var(--success-border);\n}\n\n.jp-test-name {\n  font-size: 13px;\n  color: var(--text-main);\n  font-family: 'Consolas', monospace;\n  background: var(--bg-page);\n  border: 1px solid var(--border-color);\n  padding: 3px 10px;\n  border-radius: 6px;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.jp-timer {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-family: monospace;\n  background: var(--bg-page);\n  border: 1px solid var(--border-color);\n  padding: 3px 10px;\n  border-radius: 6px;\n}\n\n.jp-triggered-by {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.jp-abort-btn {\n  background: var(--error-light);\n  border: 1px solid var(--error-border);\n  color: var(--error);\n  padding: 5px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.jp-abort-btn:hover {\n  background: #fecaca;\n  color: #b91c1c;\n}\n\n/* ---- PIPELINE STAGES ROW ---- */\n.jp-stages-row {\n  display: flex;\n  align-items: stretch;\n  padding: 14px 24px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n  overflow-x: auto;\n  gap: 0;\n  box-shadow: var(--shadow-sm);\n}\n\n.jp-stage-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.jp-stage-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 112px;\n  padding: 8px 14px;\n  border-radius: var(--border-radius-sm);\n  border: 1.5px solid var(--border-color);\n  background: var(--bg-page);\n  cursor: default;\n  transition: all 0.25s;\n  position: relative;\n}\n\n.jp-stage-block.completed {\n  border-color: var(--success-border);\n  background: var(--success-light);\n}\n\n.jp-stage-block.failed {\n  border-color: var(--error-border);\n  background: var(--error-light);\n}\n\n.jp-stage-block.running {\n  border-color: #c4b5fd;\n  background: var(--primary-light);\n  animation: jp-pulse-border 1.4s ease-in-out infinite;\n}\n\n.jp-stage-block.skipped {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n  opacity: 0.6;\n}\n\n.jp-stage-block.pending {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n  opacity: 0.45;\n}\n\n@keyframes jp-pulse-border {\n\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0.2);\n  }\n\n  50% {\n    box-shadow: 0 0 0 6px rgba(253, 97, 1, 0);\n  }\n}\n\n.jp-stage-icon {\n  font-size: 15px;\n  margin-bottom: 3px;\n  line-height: 1;\n}\n\n.jp-stage-icon.completed {\n  color: var(--success);\n}\n\n.jp-stage-icon.failed {\n  color: var(--error);\n}\n\n.jp-stage-icon.running {\n  color: var(--primary);\n}\n\n.jp-stage-icon.pending {\n  color: #cbd5e1;\n}\n\n.jp-stage-icon.skipped {\n  color: #cbd5e1;\n}\n\n.jp-stage-name {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-main);\n  text-align: center;\n  letter-spacing: 0.2px;\n  font-family: var(--font-sans);\n}\n\n.jp-stage-duration {\n  font-size: 10px;\n  color: var(--text-muted);\n  margin-top: 2px;\n  font-family: monospace;\n}\n\n.jp-stage-arrow {\n  color: #cbd5e1;\n  font-size: 12px;\n  padding: 0 6px;\n  flex-shrink: 0;\n}\n\n/* ---- MAIN CONTENT AREA ---- */\n.jp-main {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* ---- BUILD HISTORY SIDEBAR ---- */\n.jp-sidebar {\n  width: 240px;\n  min-width: 240px;\n  background: var(--bg-card);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.jp-sidebar-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.jp-sidebar-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--text-muted);\n  font-family: var(--font-sans);\n}\n\n.jp-sidebar-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.jp-build-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background 0.15s;\n  border-left: 2px solid transparent;\n}\n\n.jp-build-item:hover {\n  background: var(--bg-page);\n}\n\n.jp-build-item.active {\n  background: var(--primary-light);\n  border-left-color: var(--primary);\n}\n\n.jp-build-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.jp-build-status-dot.passed {\n  background: var(--success);\n}\n\n.jp-build-status-dot.failed {\n  background: var(--error);\n}\n\n.jp-build-status-dot.running {\n  background: var(--primary);\n  animation: jp-dot-blink 1s ease-in-out infinite;\n}\n\n.jp-build-status-dot.pending {\n  background: #cbd5e1;\n}\n\n.jp-build-status-dot.completed {\n  background: var(--success);\n}\n\n@keyframes jp-dot-blink {\n\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.4;\n    transform: scale(0.75);\n  }\n}\n\n.jp-build-item-info {\n  flex: 1;\n  overflow: hidden;\n}\n\n.jp-build-item-num {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--primary);\n  font-family: var(--font-sans);\n}\n\n.jp-build-item-name {\n  font-size: 12px;\n  color: var(--text-main);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: var(--font-sans);\n  margin-top: 1px;\n}\n\n.jp-build-item-meta {\n  font-size: 10px;\n  color: var(--text-muted);\n  margin-top: 2px;\n  font-family: monospace;\n}\n\n/* ---- CONSOLE TERMINAL ---- */\n.jp-console {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-page);\n  overflow: hidden;\n}\n\n.jp-console-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 16px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.jp-console-dot-group {\n  display: flex;\n  gap: 5px;\n}\n\n.jp-console-dot-group span {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.jp-console-dot-group .dot-red {\n  background: #ef4444;\n}\n\n.jp-console-dot-group .dot-yellow {\n  background: #f59e0b;\n}\n\n.jp-console-dot-group .dot-green {\n  background: #10b981;\n}\n\n.jp-console-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  font-family: var(--font-sans);\n}\n\n.jp-live-badge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--error);\n  background: var(--error-light);\n  border: 1px solid var(--error-border);\n  padding: 2px 8px;\n  border-radius: 20px;\n  letter-spacing: 0.5px;\n  font-family: var(--font-sans);\n}\n\n.jp-live-badge-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--error);\n  animation: jp-dot-blink 0.8s ease-in-out infinite;\n}\n\n.jp-hist-badge {\n  font-size: 10px;\n  color: var(--text-muted);\n  background: var(--bg-page);\n  border: 1px solid var(--border-color);\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-family: var(--font-sans);\n}\n\n.jp-console-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n}\n\n.jp-console-action-btn {\n  background: var(--bg-page);\n  border: 1px solid var(--border-color);\n  color: var(--text-muted);\n  font-size: 11px;\n  padding: 3px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: var(--font-sans);\n  font-weight: 500;\n}\n\n.jp-console-action-btn:hover {\n  background: var(--primary-light);\n  border-color: #c4b5fd;\n  color: var(--primary);\n}\n\n.jp-console-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px 16px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  margin: 12px;\n  border-radius: var(--border-radius-md);\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 #ffffff;\n}\n\n.jp-console-body::-webkit-scrollbar {\n  width: 5px;\n}\n\n.jp-console-body::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n\n.jp-console-body::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 4px;\n}\n\n.jp-log-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-family: 'Consolas', 'SFMono-Regular', 'Courier New', monospace;\n  font-size: 12.5px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.jp-log-line-num {\n  color: #cbd5e1;\n  min-width: 36px;\n  text-align: right;\n  user-select: none;\n  font-size: 11px;\n  padding-top: 1px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--border-color);\n  padding-right: 8px;\n  margin-right: 4px;\n}\n\n.jp-log-line-content {\n  flex: 1;\n}\n\n/* Log color classes — adjusted for light background */\n.jp-log-line.log-pass .jp-log-line-content {\n  color: #047857;\n}\n\n.jp-log-line.log-fail .jp-log-line-content {\n  color: #b91c1c;\n}\n\n.jp-log-line.log-warn .jp-log-line-content {\n  color: #92400e;\n}\n\n.jp-log-line.log-info .jp-log-line-content {\n  color: var(--primary);\n}\n\n.jp-log-line.log-stage .jp-log-line-content {\n  color: #e05300;\n  font-weight: 700;\n}\n\n.jp-log-line.log-heal .jp-log-line-content {\n  color: #c2410c;\n  font-weight: 600;\n}\n\n.jp-log-line.log-normal .jp-log-line-content {\n  color: var(--text-main);\n}\n\n.jp-log-line.log-muted .jp-log-line-content {\n  color: var(--text-muted);\n}\n\n/* Cursor */\n@keyframes jp-cursor-blink {\n\n  0%,\n  50% {\n    opacity: 1;\n  }\n\n  51%,\n  100% {\n    opacity: 0;\n  }\n}\n\n.jp-cursor {\n  color: var(--primary);\n  animation: jp-cursor-blink 1s step-start infinite;\n  font-size: 14px;\n}\n\n/* Empty state */\n.jp-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 12px;\n}\n\n.jp-empty-state-icon {\n  font-size: 40px;\n  opacity: 0.4;\n}\n\n.jp-empty-state-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-muted);\n  font-family: var(--font-sans);\n}\n\n.jp-empty-state-sub {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-family: var(--font-sans);\n}\n\n/* Result summary bar */\n.jp-result-summary {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 10px 16px;\n  background: var(--bg-card);\n  border-top: 1px solid var(--border-color);\n  flex-shrink: 0;\n  font-family: var(--font-sans);\n}\n\n.jp-result-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 20px;\n}\n\n.jp-result-pill.pass {\n  color: #047857;\n  background: var(--success-light);\n  border: 1px solid var(--success-border);\n}\n\n.jp-result-pill.fail {\n  color: #b91c1c;\n  background: var(--error-light);\n  border: 1px solid var(--error-border);\n}\n\n.jp-result-pill.skip {\n  color: var(--text-muted);\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n}\n\n/* --- STAGE VIEW & CONSOLE TERMINAL PANEL --- */\n\n.stage-view-layout {\n  display: grid;\n  grid-template-columns: 1.8fr 1.2fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n@media (max-width: 1200px) {\n  .stage-view-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.stage-view-card {\n  background: var(--bg-card);\n  border-radius: var(--border-radius-lg);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n  overflow-x: auto;\n}\n\n.stage-view-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 4px;\n  font-family: var(--font-sans);\n}\n\n.stage-view-table th {\n  padding: 12px;\n  background: #f8fafc;\n  color: var(--text-main);\n  font-weight: 700;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Average timings row */\n.stage-avg-row td {\n  padding: 8px 12px;\n  background: #f1f5f9;\n  color: var(--text-muted);\n  font-size: 11.5px;\n  text-align: center;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.stage-avg-progress-bar {\n  width: 60px;\n  height: 4px;\n  background: #e2e8f0;\n  border-radius: 2px;\n  margin: 6px auto 0 auto;\n  overflow: hidden;\n}\n\n.stage-avg-progress-fill {\n  height: 100%;\n  background: var(--primary);\n  border-radius: 2px;\n}\n\n/* Run Row Metadata Cell */\n.stage-run-meta-cell {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px;\n  width: 160px;\n  text-align: left;\n}\n\n.stage-run-badge {\n  display: inline-block;\n  font-family: monospace;\n  font-weight: 700;\n  font-size: 12px;\n  color: #ffffff;\n  background: #64748b;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-bottom: 6px;\n}\n\n.stage-run-badge.active {\n  background: var(--primary);\n  animation: pulse-active-glow 1.5s infinite;\n}\n\n.stage-run-time {\n  font-size: 11px;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.stage-run-changes-btn {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  color: #475569;\n  background: #e2e8f0;\n  border: none;\n  border-radius: 4px;\n  padding: 3px 6px;\n  margin-top: 6px;\n  cursor: default;\n}\n\n/* Base Stage Cell */\n.stage-cell {\n  position: relative;\n  text-align: center;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 16px 8px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  vertical-align: middle;\n  min-width: 90px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.stage-cell:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n/* Cell Statuses */\n.stage-cell.passed {\n  background: #ecfdf5;\n  color: #047857;\n  border-color: #a7f3d0;\n}\n\n.stage-cell.failed {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border-color: #fecaca;\n}\n\n.stage-cell.failed::after {\n  content: \"failed\";\n  position: absolute;\n  bottom: 4px;\n  right: 6px;\n  font-size: 8.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #f87171;\n  letter-spacing: 0.3px;\n}\n\n.stage-cell.skipped {\n  background: #f8fafc;\n  color: #94a3b8;\n  border-color: #e2e8f0;\n}\n\n.stage-cell.pending {\n  background: #ffffff;\n  color: #cbd5e1;\n  border-color: #f1f5f9;\n  border-style: dashed;\n}\n\n.stage-cell.active {\n  background: #eff6ff;\n  color: #FD6101;\n  border-color: #bfdbfe;\n  animation: pulse-active-cell 1.5s infinite ease-in-out;\n}\n\n.stage-cell-loader {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid #3b82f6;\n  border-radius: 50%;\n  border-top-color: transparent;\n  animation: spin-loader 0.8s linear infinite;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n/* Animations */\n@keyframes pulse-active-cell {\n  0% {\n    background-color: #eff6ff;\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.2);\n  }\n\n  50% {\n    background-color: #dbeafe;\n    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n  }\n\n  100% {\n    background-color: #eff6ff;\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.2);\n  }\n}\n\n@keyframes pulse-active-glow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 6px rgba(253, 97, 1, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(253, 97, 1, 0);\n  }\n}\n\n@keyframes spin-loader {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* --- CONSOLE TERMINAL WINDOW --- */\n\n.console-terminal {\n  background: #020617;\n  border-radius: var(--border-radius-lg);\n  border: 1px solid #1e293b;\n  box-shadow: var(--shadow-lg);\n  display: flex;\n  flex-direction: column;\n  height: 520px;\n  overflow: hidden;\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.console-terminal-header {\n  background: #0f172a;\n  border-bottom: 1px solid #1e293b;\n  padding: 12px 18px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.console-terminal-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.console-terminal-search-input {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 11px;\n  padding: 4px 8px;\n  width: 140px;\n  outline: none;\n  font-family: inherit;\n}\n\n.console-terminal-search-input::placeholder {\n  color: #64748b;\n}\n\n.console-terminal-btn {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  color: #cbd5e1;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.console-terminal-btn:hover {\n  background: #334155;\n  color: #ffffff;\n}\n\n.console-terminal-body {\n  flex-grow: 1;\n  padding: 16px;\n  overflow-y: auto;\n  text-align: left;\n  line-height: 1.6;\n}\n\n.console-terminal-body pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-all;\n  font-size: 11.5px;\n  color: #38bdf8;\n  /* Terminal bright cyan-blue */\n  text-shadow: 0 0 1px rgba(56, 189, 248, 0.2);\n}\n\n.console-line-normal {\n  color: #cbd5e1;\n}\n\n.console-line-highlight {\n  color: #f59e0b;\n  /* yellow */\n  font-weight: 700;\n}\n\n.console-line-success {\n  color: #10b981;\n  /* green */\n  font-weight: 700;\n}\n\n.console-line-error {\n  color: #f87171;\n  /* red */\n  font-weight: 700;\n}\n\n.console-line-system {\n  color: #a78bfa;\n  /* purple */\n  font-style: italic;\n}\n\n.console-line-filtered-out {\n  display: none;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loader-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* ==========================================================================\n   UNIVERSAL RESPONSIVE STYLING OVERHAUL\n   ========================================================================== */\n\n/* Hamburger toggle menu (hidden by default on desktop) */\n.mobile-menu-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: var(--text-main);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n.mobile-menu-toggle:hover {\n  background-color: #f1f5f9;\n}\n\n.mobile-menu-toggle svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Base layouts responsive rules for 100% zoom and multi-resolution */\n@media (max-width: 1440px) {\n\n  /* Hide bulky header widgets so greeting and action buttons never collide */\n  .header-widgets-container {\n    display: none !important;\n  }\n\n  /* 2 rows of 3 compact cards so all 6 cards are visible and save 150px vertical height */\n  .metrics-grid {\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .metric-card {\n    padding: 12px 14px !important;\n  }\n\n  .metric-value {\n    font-size: 20px !important;\n  }\n\n  .metric-label {\n    font-size: 11.5px !important;\n    margin-bottom: 3px !important;\n  }\n\n  /* Stack mid-section so creation cards have full container width */\n  .mid-section-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n\n  /* Generous 2-column or auto-fit cards where all text and buttons are 100% visible */\n  .creation-cards-row {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;\n    gap: 12px !important;\n  }\n\n  .creation-card {\n    padding: 12px 14px !important;\n  }\n\n  .creation-icon-graphic {\n    height: 46px !important;\n    margin-bottom: 8px !important;\n  }\n\n  .creation-title {\n    font-size: 13px !important;\n    font-weight: 700 !important;\n    white-space: normal !important;\n    overflow-wrap: break-word !important;\n    margin-bottom: 4px !important;\n  }\n\n  .creation-desc {\n    font-size: 11px !important;\n    line-height: 1.35 !important;\n    margin-bottom: 10px !important;\n    min-height: auto !important;\n  }\n\n  .insights-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n\n  .bottom-section-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n}\n\n/* Responsive text & character resilience for 100% zoom */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nspan,\na,\nlabel {\n  overflow-wrap: break-word;\n}\n\n.table-container,\n.table-responsive,\ndiv[style*=\"overflowX: auto\"],\ndiv[style*=\"overflow-x: auto\"] {\n  max-width: 100%;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\ntd,\nth {\n  overflow-wrap: break-word;\n}\n\n@media (max-width: 1440px) {\n  .metrics-grid {\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 14px !important;\n  }\n\n  .insights-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n@media (max-width: 1100px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .insights-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .creation-cards-row {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n\n  .gen-tabs-row {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n@media (max-height: 850px) {\n  .modal-card {\n    padding: 18px 20px !important;\n    max-height: calc(100vh - 24px) !important;\n  }\n\n  .modal-input-group {\n    margin-bottom: 12px !important;\n  }\n\n  .modal-card textarea {\n    height: 80px !important;\n    min-height: 55px !important;\n  }\n\n  .modal-title {\n    font-size: 16px !important;\n    margin-bottom: 12px !important;\n  }\n}\n\n@media (max-height: 700px) {\n  .modal-card {\n    padding: 14px 16px !important;\n    max-height: calc(100vh - 16px) !important;\n  }\n\n  .modal-input-group {\n    margin-bottom: 8px !important;\n  }\n\n  .modal-card textarea {\n    height: 60px !important;\n    min-height: 45px !important;\n  }\n\n  .modal-title {\n    font-size: 15px !important;\n    margin-bottom: 8px !important;\n  }\n}\n\n@media (max-width: 1024px) {\n\n  /* Header actions and buttons must never be crushed */\n  .header-actions {\n    flex-shrink: 0 !important;\n    white-space: nowrap !important;\n  }\n\n  .btn-new-project {\n    flex-shrink: 0 !important;\n    white-space: nowrap !important;\n  }\n}\n\n/* Compact sidebar on screens between 769px and 1250px */\n@media (max-width: 1250px) {\n\n  .sidebar,\n  .modern-sidebar {\n    width: 215px !important;\n    padding: 16px 10px !important;\n  }\n}\n\n@media (max-width: 800px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 10px !important;\n  }\n\n  .insights-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .creation-cards-row {\n    grid-template-columns: 1fr !important;\n  }\n\n  .main-content {\n    padding: 14px 16px !important;\n  }\n\n  .main-header {\n    padding: 0 16px !important;\n    margin: 10px 16px 4px 16px !important;\n    border-radius: 16px !important;\n  }\n}\n\n@media (max-height: 850px) {\n  .metric-card {\n    padding: 10px 12px !important;\n  }\n\n  .metric-value {\n    font-size: 18px !important;\n  }\n\n  .creation-icon-graphic {\n    height: 40px !important;\n    margin-bottom: 6px !important;\n  }\n\n  .creation-desc {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n}\n\n@media (max-height: 700px) {\n  .metrics-grid {\n    margin-bottom: 12px !important;\n  }\n\n  .creation-icon-graphic {\n    height: 36px !important;\n    margin-bottom: 4px !important;\n  }\n}\n\n@media (max-width: 900px) {\n\n  /* Stack test repository grids into single column */\n  .repo-grid {\n    grid-template-columns: 1fr !important;\n    gap: 20px;\n  }\n\n  .manual-grid {\n    grid-template-columns: 1fr !important;\n    gap: 20px;\n  }\n\n  .repo-sidebar,\n  .manual-sidebar {\n    min-height: auto !important;\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* Transform Sidebar into a slide-out drawer on mobile */\n  .sidebar {\n    position: fixed !important;\n    top: 0;\n    left: -260px;\n    z-index: 10001;\n    height: 100vh !important;\n    width: 250px !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.15) !important;\n    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    background-color: var(--bg-sidebar) !important;\n    border-right: 1px solid var(--border-color) !important;\n  }\n\n  .sidebar.mobile-open {\n    left: 0 !important;\n  }\n\n  /* Overlay background layer */\n  .sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(15, 23, 42, 0.4);\n    backdrop-filter: blur(4px);\n    z-index: 10000;\n  }\n\n  /* Show hamburger button */\n  .mobile-menu-toggle {\n    display: flex !important;\n  }\n\n  /* Header adjustments for space saving */\n  .main-header {\n    padding: 10px 16px !important;\n    margin: 8px 12px 4px 12px !important;\n    border-radius: 16px !important;\n    min-height: 70px;\n    height: auto !important;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .header-welcome h1 {\n    font-size: 18px !important;\n  }\n\n  .header-welcome p {\n    font-size: 11px !important;\n  }\n\n  /* Generator tab adjustments */\n  .gen-tabs-row {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 8px;\n  }\n\n  /* Creation Option Cards wrapping */\n  .creation-cards-row {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px;\n  }\n\n  /* User profile dropdown alignment */\n  .header-actions {\n    gap: 10px !important;\n  }\n\n  .btn-new-project span {\n    display: none;\n    /* Hide 'New Project' text on mobile, keep icon */\n  }\n\n  .btn-new-project {\n    padding: 10px 12px !important;\n  }\n}\n\n@media (max-width: 576px) {\n\n  /* Stats Cards alignment stacking */\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .creation-cards-row {\n    grid-template-columns: 1fr !important;\n  }\n\n  .gen-tabs-row {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n@media (max-width: 400px) {\n  .metrics-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* Ensure clean scrolling and no double horizontal bars on the main screen */\n.main {\n  width: 100%;\n  overflow-x: hidden !important;\n}\n\n.main-content {\n  overflow-x: hidden !important;\n}\n\n.main-content.simulator-content-active {\n  padding: 0 !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n  height: calc(100vh - 70px) !important;\n  max-height: calc(100vh - 70px) !important;\n  background-color: #f1f5f9 !important;\n}\n\n/* ==========================================================================\n   SMART RESPONSIVE SIMULATOR WORKSPACE STYLES - QINTRA MODERN THEME\n   ========================================================================== */\n\n.simulator-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: #f8fafc;\n}\n\n/* 1. Simulator Top Toolbar */\n.simulator-toolbar {\n  min-height: 56px;\n  height: 56px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  gap: 10px;\n  flex-shrink: 0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  z-index: 10;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n/* Navigation buttons group */\n.toolbar-nav-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n/* URL bar form */\n.simulator-url-form {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 420px;\n  min-width: 360px;\n  max-width: 600px;\n  flex-shrink: 0;\n}\n\n.simulator-url-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 220px;\n}\n\n.simulator-url-icon {\n  position: absolute;\n  left: 11px;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.simulator-url-input {\n  width: 100%;\n  height: 38px;\n  border-radius: 8px;\n  border: 1.5px solid #cbd5e1;\n  padding: 0 32px 0 34px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  outline: none;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.simulator-url-input:hover {\n  border-color: #94a3b8;\n}\n\n.simulator-url-input:focus {\n  border-color: #FD6101;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.15);\n}\n\n.simulator-url-clear-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 2;\n  padding: 0;\n  line-height: 1;\n}\n\n.simulator-url-clear-btn:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n  transform: translateY(-50%) scale(1.08);\n}\n\n/* Toolbar Control Groups */\n.toolbar-control-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.toolbar-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.toolbar-select {\n  height: 36px;\n  border-radius: 8px;\n  border: 1.5px solid #e2e8f0;\n  padding: 0 28px 0 10px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-main);\n  outline: none;\n  background-color: #ffffff;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.toolbar-select:hover {\n  border-color: #cbd5e1;\n}\n\n.toolbar-select:focus {\n  border-color: #FD6101;\n  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.1);\n}\n\n.toolbar-select.zoom-select {\n  width: 125px;\n}\n\n.toolbar-select.vision-select {\n  width: 155px;\n}\n\n/* Viewport dimensions input */\n.toolbar-num-input {\n  width: 62px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1.5px solid #e2e8f0;\n  padding: 0 4px;\n  font-size: 12.5px;\n  font-weight: 700;\n  text-align: center;\n  outline: none;\n  color: var(--text-main);\n  background-color: #ffffff;\n  transition: border-color 0.2s ease;\n}\n\n.toolbar-num-input:focus {\n  border-color: #FD6101;\n  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.1);\n}\n\n.toolbar-x {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 700;\n}\n\n/* Zoom controls block */\n.toolbar-zoom-buttons {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #ffffff;\n  overflow: hidden;\n  height: 36px;\n  flex-shrink: 0;\n}\n\n.toolbar-zoom-buttons .toolbar-btn {\n  border: none;\n  border-radius: 0;\n  height: 100%;\n  padding: 0 10px;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toolbar-zoom-buttons .toolbar-btn:first-child {\n  border-right: 1.5px solid #e2e8f0;\n}\n\n.toolbar-zoom-buttons .toolbar-btn:last-child {\n  border-left: 1.5px solid #e2e8f0;\n}\n\n.zoom-display {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--text-main);\n  min-width: 44px;\n  text-align: center;\n  user-select: none;\n}\n\n/* Toolbar buttons */\n.toolbar-btn {\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1.5px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 8px;\n  color: var(--text-main);\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0 12px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.toolbar-btn:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.toolbar-btn.primary {\n  background: #FD6101;\n  color: #ffffff;\n  border: none;\n  box-shadow: 0 2px 6px rgba(253, 97, 1, 0.25);\n}\n\n.toolbar-btn.primary:hover {\n  background: #e05300;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(224, 83, 0, 0.35);\n}\n\n.toolbar-btn.active {\n  background-color: #fff7ed;\n  color: #FD6101;\n  border-color: #FD6101;\n  font-weight: 700;\n}\n\n.toolbar-btn svg {\n  color: #64748b;\n  transition: color 0.2s;\n}\n\n.toolbar-btn:hover svg {\n  color: var(--text-main);\n}\n\n.toolbar-btn.primary svg {\n  color: #ffffff;\n}\n\n.toolbar-divider {\n  width: 1px;\n  height: 24px;\n  background-color: #e2e8f0;\n  margin: 0 2px;\n  flex-shrink: 0;\n}\n\n/* 2. Breakpoint Snap Bar */\n.simulator-ruler {\n  min-height: 42px;\n  height: 42px;\n  background-color: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  gap: 8px;\n  overflow-x: auto;\n  flex-shrink: 0;\n  user-select: none;\n  scrollbar-width: thin;\n}\n\n.breakpoint-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 11px;\n  border-radius: 20px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.breakpoint-pill:hover {\n  border-color: #FD6101;\n  color: #FD6101;\n  background: #fff7ed;\n  transform: translateY(-1px);\n}\n\n.breakpoint-pill.active {\n  background: #FD6101;\n  color: #ffffff;\n  border-color: transparent;\n  font-weight: 700;\n  box-shadow: 0 2px 8px rgba(253, 97, 1, 0.3);\n}\n\n.breakpoint-pill.active:hover {\n  background: #e05300;\n}\n\n.breakpoint-pill.active .bp-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.bp-width {\n  font-weight: 700;\n}\n\n.bp-label {\n  font-size: 10px;\n  opacity: 0.8;\n}\n\n/* 3. Simulator Canvas Area */\n.simulator-canvas-container {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 36px;\n  position: relative;\n  user-select: none;\n}\n\n.simulator-canvas-container.theme-dots {\n  background-color: #f1f5f9;\n  background-image: radial-gradient(#cbd5e1 1.5px, transparent 1.5px);\n  background-size: 20px 20px;\n}\n\n.simulator-canvas-container.theme-dark {\n  background-color: #0b0f19;\n  background-image: radial-gradient(#1e293b 1.5px, transparent 1.5px);\n  background-size: 20px 20px;\n}\n\n.simulator-canvas-container.theme-clean {\n  background-color: #f8fafc;\n}\n\n/* Realistic Device Frame Wrappers */\n.simulator-frame-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.08);\n  background-color: #ffffff;\n  transition: box-shadow 0.2s ease;\n}\n\n/* Desktop browser mockup window chrome */\n.simulator-frame-wrapper.frame-desktop {\n  border-radius: 12px;\n  border: 1px solid #cbd5e1;\n  overflow: hidden;\n}\n\n.desktop-chrome-bar {\n  height: 34px;\n  background: #f1f5f9;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  gap: 12px;\n  user-select: none;\n}\n\n.mac-traffic-lights {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mac-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.mac-dot.red {\n  background-color: #ef4444;\n}\n\n.mac-dot.yellow {\n  background-color: #f59e0b;\n}\n\n.mac-dot.green {\n  background-color: #10b981;\n}\n\n.desktop-chrome-title {\n  flex: 1;\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 600;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.desktop-chrome-badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #475569;\n  background: #e2e8f0;\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-family: monospace;\n}\n\n/* Mobile Device Shell */\n.simulator-frame-wrapper.frame-mobile {\n  border-radius: 42px;\n  border: 11px solid #0f172a;\n  box-shadow: 0 30px 70px -15px rgba(0, 0, 0, 0.4), 0 0 0 2px #334155;\n  background-color: #0f172a;\n  overflow: hidden;\n}\n\n.mobile-island-bar {\n  position: absolute;\n  top: 6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 96px;\n  height: 22px;\n  background-color: #000000;\n  border-radius: 14px;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mobile-camera-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #1e293b;\n  border-radius: 50%;\n  margin-left: auto;\n  margin-right: 10px;\n}\n\n/* Tablet Device Shell */\n.simulator-frame-wrapper.frame-tablet {\n  border-radius: 28px;\n  border: 13px solid #0f172a;\n  box-shadow: 0 30px 70px -15px rgba(0, 0, 0, 0.35), 0 0 0 2px #334155;\n  background-color: #0f172a;\n  overflow: hidden;\n}\n\n.tablet-camera-dot {\n  position: absolute;\n  top: 5px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 7px;\n  height: 7px;\n  background-color: #1e293b;\n  border-radius: 50%;\n  z-index: 20;\n}\n\n/* Embedded preview iframe */\n.simulator-iframe {\n  border: none;\n  background-color: #ffffff;\n  display: block;\n  flex: 1;\n}\n\n/* Resize Handles */\n.sim-resize-handle {\n  position: absolute;\n  background-color: transparent;\n  z-index: 100;\n  transition: background-color 0.2s;\n}\n\n.sim-resize-handle.right {\n  top: 0;\n  right: -8px;\n  width: 14px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.sim-resize-handle.right:hover {\n  background: rgba(253, 97, 1, 0.25);\n}\n\n.sim-resize-handle.bottom {\n  left: 0;\n  bottom: -8px;\n  width: 100%;\n  height: 14px;\n  cursor: ns-resize;\n}\n\n.sim-resize-handle.bottom:hover {\n  background: rgba(253, 97, 1, 0.25);\n}\n\n.sim-resize-handle.corner {\n  right: -9px;\n  bottom: -9px;\n  width: 20px;\n  height: 20px;\n  cursor: nwse-resize;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 3px solid #FD6101;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sim-resize-handle.corner::after {\n  content: '';\n  width: 4px;\n  height: 4px;\n  background-color: #FD6101;\n  border-radius: 50%;\n}\n\n/* 4. Bottom Simulator Status Bar */\n.simulator-status-bar {\n  height: 34px;\n  background-color: #ffffff;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex-shrink: 0;\n  user-select: none;\n}\n\n.status-left-group,\n.status-right-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.status-label {\n  color: #94a3b8;\n  text-transform: uppercase;\n  font-size: 9px;\n  letter-spacing: 0.5px;\n  font-weight: 700;\n}\n\n.status-value {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.status-badge {\n  padding: 2px 6px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 10px;\n  font-family: monospace;\n}\n\n/* Active Fullscreen overrides */\n.app.fullscreen-active .sidebar {\n  display: none !important;\n}\n\n.app.fullscreen-active .main-header {\n  display: none !important;\n}\n\n.app.fullscreen-active .main-content {\n  padding: 0 !important;\n}\n\n.rotate-btn:hover svg {\n  transform: rotate(90deg);\n  transition: transform 0.3s ease;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Sidebar transition and collapse styles */\n.sidebar {\n  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1), padding 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.sidebar.collapsed {\n  width: 70px !important;\n  padding: 24px 8px !important;\n}\n\n.sidebar.collapsed .sidebar-logo {\n  justify-content: center !important;\n}\n\n.sidebar.collapsed .sidebar-logo div {\n  display: none !important;\n}\n\n.sidebar.collapsed .menu-group-label {\n  display: none !important;\n}\n\n.sidebar.collapsed .sidebar-menu-btn {\n  font-size: 0 !important;\n  justify-content: center !important;\n  padding: 10px 0 !important;\n  gap: 0 !important;\n}\n\n.sidebar.collapsed .sidebar-menu-btn svg {\n  margin: 0 !important;\n}\n\n.sidebar.collapsed .sidebar-submenu-btn {\n  font-size: 0 !important;\n  justify-content: center !important;\n  padding: 8px 0 !important;\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n/* ==========================================================================\n   NEW PREMIUM BUG REPORT STYLES\n   ========================================================================== */\n\n/* Grid and layout wrappers */\n.bug-grid-premium {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 24px;\n  margin-top: 16px;\n}\n\n.bug-grid-compact {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n/* Premium Card Style */\n.bug-card-premium {\n  position: relative;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04), 0 2px 8px -1px rgba(15, 23, 42, 0.02);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  text-align: left;\n}\n\n.bug-card-premium::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n}\n\n.bug-card-premium.severity-critical::before {\n  background: #ef4444;\n}\n\n.bug-card-premium.severity-high::before {\n  background: #FD6101;\n}\n\n.bug-card-premium.severity-medium::before {\n  background: #eab308;\n}\n\n.bug-card-premium.severity-low::before {\n  background: #3b82f6;\n}\n\n.bug-card-premium:hover {\n  transform: translateY(-4px) scale(1.01);\n  box-shadow: 0 12px 24px -4px rgba(15, 23, 42, 0.08), 0 4px 12px -2px rgba(15, 23, 42, 0.04);\n  border-color: #FD6101;\n}\n\n/* Compact Card Style */\n.bug-card-compact {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n  transition: all 0.2s ease;\n  text-align: left;\n  overflow: hidden;\n}\n\n.bug-card-compact::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n}\n\n.bug-card-compact.severity-critical::before {\n  background-color: #ef4444;\n}\n\n.bug-card-compact.severity-high::before {\n  background-color: #f97316;\n}\n\n.bug-card-compact.severity-medium::before {\n  background-color: #eab308;\n}\n\n.bug-card-compact.severity-low::before {\n  background-color: #3b82f6;\n}\n\n.bug-card-compact:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);\n  border-color: #cbd5e1;\n}\n\n/* Header/ID/Tag elements */\n.bug-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bug-id-badge {\n  font-family: 'Fira Code', monospace, Courier;\n  font-size: 13px;\n  font-weight: 700;\n  color: #475569;\n  background: #f1f5f9;\n  padding: 4px 8px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.bug-id-badge:hover {\n  background: #e2e8f0;\n  color: var(--primary);\n}\n\n.bug-id-badge svg {\n  opacity: 0.5;\n  transition: opacity 0.2s;\n}\n\n.bug-id-badge:hover svg {\n  opacity: 1;\n}\n\n/* Title & Breadcrumbs */\n.bug-card-title {\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: #0f172a;\n  margin: 0;\n  transition: color 0.2s;\n}\n\n.bug-card-breadcrumbs {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n/* Diagnostic Code Box */\n.bug-diagnostic-box {\n  background: #0f172a;\n  color: #e2e8f0;\n  font-family: 'Fira Code', monospace, Courier;\n  font-size: 12px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  overflow: auto;\n  max-height: 120px;\n  border-left: 4px solid #ef4444;\n  text-align: left;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.bug-diagnostic-box.warning {\n  border-left-color: #f97316;\n}\n\n/* Tab controls inside bug card */\n.bug-tab-bar {\n  display: flex;\n  gap: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 6px;\n}\n\n.bug-tab-btn {\n  background: none;\n  border: none;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #64748b;\n  padding: 4px 8px;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s;\n}\n\n.bug-tab-btn.active {\n  color: var(--primary);\n}\n\n.bug-tab-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -7px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: var(--primary);\n}\n\n/* Confidence gauge meter */\n.confidence-meter-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.confidence-bar-bg {\n  height: 6px;\n  background: #e2e8f0;\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n}\n\n.confidence-bar-fill {\n  height: 100%;\n  background: #10b981;\n  border-radius: 3px;\n  box-shadow: 0 0 8px rgba(16, 185, 129, 0.4);\n}\n\n/* Card Actions */\n.bug-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: auto;\n}\n\n/* Healing overlay spinner inside card */\n.healing-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  z-index: 10;\n  animation: fadeIn 0.2s ease;\n}\n\n.healing-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(253, 97, 1, 0.1);\n  border-left-color: #FD6101;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.healing-text {\n  font-size: 13px;\n  font-weight: 700;\n  color: #FD6101;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* Copy alert tooltip */\n.copy-tooltip {\n  position: absolute;\n  background: #0f172a;\n  color: #ffffff;\n  font-size: 11px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  animation: tooltipFade 0.2s ease;\n  z-index: 20;\n}\n\n@keyframes tooltipFade {\n  from {\n    opacity: 0;\n    transform: translate(-50%, 5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n/* ==========================================================================\n   IMAGE 3 AESTHETICS OVERHAUL - SOFT PASTELS & DEEP ROUNDED NESTED CARDS\n   ========================================================================== */\n\n/* Grid and layout wrappers */\n.bug-grid-image1 {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 24px;\n  margin-top: 16px;\n}\n\n.bug-card-image1 {\n  border-radius: 28px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 10px 25px -15px rgba(0, 0, 0, 0.06);\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  text-align: left;\n  border: 2px solid transparent;\n}\n\n/* Color matched soft pastel backgrounds */\n.bug-card-image1.severity-critical {\n  background: #fdf2f2;\n  border-color: #fde2e2;\n}\n\n.bug-card-image1.severity-high {\n  background: #fff7ed;\n  border-color: #ffedd5;\n}\n\n.bug-card-image1.severity-medium {\n  background: #fffbeb;\n  border-color: #fef3c7;\n}\n\n.bug-card-image1.severity-low {\n  background: #f0f9ff;\n  border-color: #e0f2fe;\n}\n\n.bug-card-image1.status-passed,\n.bug-card-image1.status-healed {\n  background: #f0fdf4;\n  border-color: #dcfce7;\n}\n\n.bug-card-image1:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 35px -12px rgba(0, 0, 0, 0.1);\n}\n\n.bug-card-image1::before {\n  display: none !important;\n}\n\n/* Card Header */\n.brand-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.brand-label-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.brand-icon-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #0f172a;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.brand-name-text {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n/* Soft Severity Pill Badge */\n.severity-pill-image1 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 30px;\n  font-size: 11px;\n  font-weight: 700;\n  border: 1px solid transparent;\n}\n\n.severity-pill-image1.low {\n  background-color: #ffffff;\n  color: #0284c7;\n  border-color: #e0f2fe;\n}\n\n.severity-pill-image1.medium {\n  background-color: #ffffff;\n  color: #d97706;\n  border-color: #fef3c7;\n}\n\n.severity-pill-image1.high {\n  background-color: #ffffff;\n  color: #ea580c;\n  border-color: #ffedd5;\n}\n\n.severity-pill-image1.critical {\n  background-color: #ffffff;\n  color: #ef4444;\n  border-color: #fee2e2;\n}\n\n/* Nested White Details Card */\n.nested-white-card {\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Sub-grid Metadata Blocks */\n.meta-block-grid-image1 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.meta-cell-image1 {\n  background-color: transparent;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  text-align: left;\n  border: none;\n}\n\n.meta-cell-label {\n  font-size: 9.5px;\n  font-weight: 700;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.meta-cell-value {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* Card Body text elements */\n.bug-title-image1 {\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 2px 0;\n  line-height: 1.4;\n}\n\n.bug-desc-image1 {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Dark Accent buttons inspired by Card 1 in Image 3 */\n.btn-pill-primary {\n  background-color: #0f172a;\n  color: #ffffff;\n  border: none;\n  border-radius: 30px;\n  padding: 10px 20px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.btn-pill-primary:hover {\n  background-color: #1e293b;\n  transform: translateY(-1px);\n}\n\n.btn-pill-secondary {\n  background-color: #ffffff;\n  color: #0f172a;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 30px;\n  padding: 10px 20px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.btn-pill-secondary:hover {\n  background-color: #f1f5f9;\n  transform: translateY(-1px);\n}\n\n/* ==========================================================================\n   UNIVERSAL RABBIT BRAND CUSTOM SCROLLBAR & OVERFLOW DESIGN SYSTEM\n   ========================================================================== */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 9999px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.35);\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(253, 97, 1, 0.45);\n}\n\n.table-responsive,\n.table-container,\n.modal-body,\n.sidebar,\n.page-wrapper,\n.main-wrapper {\n  overflow-y: auto !important;\n  overflow-x: auto !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
